<template>
  <div class="page-container" :class="{ 'is-mobile-scale': enableMobileScale }" :style="mobileScaleStyle">
    <div class="pc-scale-content">
    <div class="user-entry-bar">
      <div class="user-mail-button" title="给管理员写信" @click.stop="handleMailboxClick">
        <div class="mc-envelope" :class="{ open: mailboxHover }" @mouseenter="mailboxHover = true" @mouseleave="mailboxHover = false">
          <div class="env-body"></div>
          <div class="env-flap"></div>
          <div class="env-letter"></div>
        </div>
      </div>

      <div class="user-entry" @click="handleUserEntryClick">
        <template v-if="userLoggedIn">
          <img :src="userAvatar" class="user-entry-avatar" alt="avatar" />
          <div class="user-entry-name">{{ userNickname }}</div>
        </template>
        <template v-else>
          <div class="user-entry-login">登录</div>
        </template>
      </div>
    </div>

    <header class="reveal-section">
      <!-- <h1 style="font-size: 5rem; text-shadow: 8px 8px #000;">云边小镇</h1> -->
      <!-- <p>「 SCALLION TOWN - THE EPISODE OF ETERNITY 」</p> -->
      <div class="scroll-hint" :style="{ opacity: scrollHintOpacity, filter: `blur(${scrollHintBlur}px)` }"
        @click="scrollToNext">
        <div class="scroll-hint-text">往下阅览</div>
        <div class="scroll-hint-arrows">
          <div class="scroll-arrow"></div>
          <div class="scroll-arrow"></div>
        </div>
      </div>
    </header>

    <!-- 轮播图展示区（来自 /set 的轮播图管理：/api/carousels；点击不跳转） -->
    <div class="hero-carousel-wrapper reveal-section" v-if="carousels.length > 0 && carouselsReady">
      <div class="hero-carousel-container">
        <div class="hero-carousel-inner" :style="{ transform: `translateX(-${currentCarouselIndex * 100}%)` }">
          <div v-for="(carousel, index) in carousels" :key="'hero-carousel-' + (carousel.id || index)"
            class="hero-carousel-item" :style="{ backgroundImage: `url(${carousel.imageUrl})` }" @click.prevent>
            <div class="hero-carousel-overlay" v-if="carousel.title">
              <h3>{{ carousel.title }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>



    <section class="founder-strip reveal-section">
      <a
        class="founder-avatar-link"
        href="https://www.mosicong.top/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="访问 https://www.mosicong.top/"
        @mousemove="handleAvatarMouseMove"
        @mouseleave="handleAvatarMouseLeave"
        ref="avatarLink"
      >
        <div class="confetti-container" v-show="isAvatarHovered">
          <div v-for="i in 12" :key="i" class="confetti-bit"></div>
        </div>
        <img
          src="https://mosicong.oss-cn-guangzhou.aliyuncs.com/img/%E6%88%91%E7%9A%84%E4%B8%96%E7%95%8C%E7%9A%AE%E8%82%A4%E5%A4%B4%E5%83%8F.jpg"
          class="founder-avatar" 
          alt="小葱"
          :style="avatarTiltStyle"
        >
      </a>
      <div class="founder-text">
        <h2 style="font-size: 24px;">小镇创始人：小葱 (Dear_Monster)</h2>
        <p style="font-size: 12px; line-height: 2.5; color: #d1e8b9; margin-top: 20px; text-align: justify;">
          我是一位Java后端实习生，也是一位《我的世界》的爱好者！至今玩《我的世界》已经有十余个年头了，当人问起《我的世界》有这么好的玩吗？我会回复：这就是我的童年。断断续续我玩过很多个服务器，不过很遗憾，之前玩的所有的服务器都被我玩倒闭了...在2024年7月11日，我正式来到如今的服务器————像素之梦，正所谓万物轮回，这一世我又出生了！！我不知道这个服务器能活多久，不过如果你愿意，你可以来服务器中找我玩！在学Java的路上，并没有红石装置那么简单，因为《我的世界》，所以我才选了Java，相互成就，相互进步！此后的我也会朝着我心中所想的目标更加迈进。陌生人，感谢你聆听我的故事~
        </p>
      </div>
    </section>

    <section class="notice-board reveal-section">
      <h2 style="margin-bottom: 25px;">公告栏</h2>
      <div class="board-container" id="board-container">
        <div v-for="notice in notices" :key="notice.id" class="notice-item">
          [{{ getTypeName(notice.type) }}] {{ notice.content }}
        </div>
        <div v-for="un in userNotices" :key="'u-' + un.id" class="notice-item">
          [{{ un.nickname }}] {{ un.content }}
        </div>
      </div>
    </section>

    <section class="desc-section reveal-section">
      <div class="desc-scroll">
        <h2>小镇简介</h2>
        <!-- <p>&nbsp;&nbsp;<br>在那片被远古迷雾遮蔽的原始丛林边缘，文明的第一缕火把终于点亮。小葱镇并非一日建成，它是无数开拓者在荒芜的方块大地上留下的集体意志结晶。从最初为了躲避僵尸侵袭而挖掘的简陋石穴，到如今耸入云端的宏伟红石尖塔，每一块泥土都浸透了汗水。我们在这里追求的不单纯是物理意义上的生存，更是一种对于纯粹美的艺术表达。在这里，你可以听见海浪拍打港口木板的呼吸，可以看见深夜红石中继器跳动的韵律。小葱镇不仅是一座堡垒，它是所有流浪在方块世界中，渴望寻找灵魂归属的人们共同构筑的温馨避风港。无论是建筑大师还是红石狂人，都能在葱郁的平原上找到属于自己的那一块土地。</p> -->
        <p>&nbsp;&nbsp;在那片被远古迷雾遮蔽的原始丛林边缘，文明的第一缕火把终于点亮，在一个蝉鸣的盛夏，当第一块泥土被挖开，云边小镇将在泥土中拔地而起！
          <br>&nbsp;&nbsp;欢迎你来到云边小镇！小镇创建成立于2024年7月13日。小镇地势趋于山谷与河流之间，地势偏高，部分山峦之间更有云层穿过，故得名于云边小镇。
          <br>&nbsp;&nbsp;云中城是云边小镇第一个开始施工的项目，它位于天坑之上，宏伟壮观，是一个大型的浮空岛屿，这标志着它将成为小镇的中心。它见证着小镇的发展，也接纳着无数玩家。
          <br>&nbsp;&nbsp;小镇的发展曲折波澜，从原先的一块草地不断延续，因为服务器中小镇数量居多，在前期很难招募到成员一起共建小镇，从曾经一个不太看好的小镇，到如今也有了些规模，这期间当然少不了小伙伴们的热爱与付出，感谢有你们！
          <br>&nbsp;&nbsp;小镇目前正在努力打造服内大型的休闲建筑小镇，基础实施也在不断的完善中，适合刚入坑的萌新朋友们，在这里你可以得到很多补助，如：免费甘蔗、蜂胚、羊毛、火药、骨粉、铁锭等等一系列基础物质。小镇内还设有百货商店、展示厅、各类餐厅，以及一个大型的竞技场供小镇成员pvp娱乐。在这里，你可以结交到好朋友，也可以享受建筑给你来带的乐趣！
          <br>&nbsp;&nbsp;云边小镇不设有镇长，每一个玩家的辛勤付出都知道被肯定！小镇广纳贤才，尚有大片空地等你来开发！在云边小镇，不分高低贵贱，不分年龄，只要你热爱建筑，无论你的建筑水平如何，随时都可以加入我们！共同打造属于我们的世界！
          <br>&nbsp;&nbsp;
          <br>&nbsp;&nbsp;<b><i>云边小镇地址：yuntown 游戏内聊天窗口输入/res tp yuntown 即可抵达小镇。</i></b>
          <br>
          <br>
          <br>
          <b>
            <div class="desc-signature">
              <div class="sig-content">
                <div class="sig-line">生存一区</div>
                <div class="sig-line">Dear_Monster</div>
                <div class="sig-line">2026年2月7日</div>
              </div>
            </div>
          </b>
        </p>
      </div>
    </section>

    <section class="rules-section reveal-section">
      <h2 style="color: #fff; margin-bottom: 20px;">云边镇规</h2>
      <div class="rules-container">
        <div class="rule-card">
          <h4>I. 环境保护公约</h4>
          <p>
            <br>&nbsp;&nbsp;1.不允许破坏周边环境，包括但不限于开采树木，破坏土地，挖穿河道，过度开采资源。
            <br>&nbsp;&nbsp;2.不允许杀害家养生物，包括但不限于家养村民僵尸，村民，猪牛羊等。
            <br>&nbsp;&nbsp;3.不允许损坏小镇基础设施，包括但不限于路灯，道路，桥梁。
            <br>&nbsp;&nbsp;4.不允许损坏房屋，若是自己的房屋请及时圈地！不可损坏他人未及时圈地的房屋。
          </p>
        </div>
        <div class="rule-card">
          <h4>II. 建筑房屋管理条约</h4>
          <p>
            <br>&nbsp; 1.建筑房屋时必须先圈地，用多少地圈多少地，不允许浪费土地资源。
            <br>&nbsp;&nbsp;2.若要平地，需与环境先融合，不能因平地而破坏环境。
            <br>&nbsp;&nbsp;3.一旦圈地建筑必须完工，不可烂尾！烂尾的建筑没人可以打理，会影响小镇的美观。
            <br>&nbsp;&nbsp;4.建筑尽可能要保持美观，不可杂乱无边不加修饰，不过只要你打理的好，是火柴盒也没有关系~
          </p>
        </div>
        <div class="rule-card">
          <h4>III. 小镇文明公约</h4>
          <p>
            <br>&nbsp;&nbsp;1.小镇成员需要互帮互助，不可歧视新手玩家，不可有霸凌的行为出现。
            <br>&nbsp;&nbsp;2.不可未经对方允许偷拿物品， 以及禁止任何的言语辱骂行为。
            <br>&nbsp;&nbsp;3.小镇成员应当有维护小镇的责任，及时举报破坏小镇的玩家，并参与到修缮小镇的工作中来。
            <br>&nbsp;&nbsp;4.云边小镇不搞独裁，欢迎其他小镇的成员来云边小镇建家，也欢迎云边小镇成员去其他小镇建家，小镇与小镇之间不设对立。
          </p>
        </div>
      </div>
    </section>

    <section class="map-wrapper reveal-section">
      <div id="town-map"></div>
    </section>

    <section class="members-area reveal-section">
      <h2>小镇居民</h2>
      <div class="sign-grid">
        <div v-for="resident in residents" :key="resident.id" class="oak-sign-box" @click="tapSign(resident.name)">
          <div class="oak-sign-body">
            <div class="oak-sign-name" :style="getNameFitStyle(resident.name)">{{ resident.name }}</div>
            <div class="oak-sign-sep">---</div>
            <div class="oak-sign-title">[ {{ resident.title }} ]</div>
          </div>
          <div class="oak-sign-stick"></div>
        </div>
      </div>
    </section>

    <section class="building-gallery reveal-section">
      <h2 style="text-align: center; margin-bottom: 40px;">小镇建筑展示</h2>
      <div class="gallery-track" id="gallery-track" ref="galleryTrack" @click="handleGalleryClick">
        <!-- 复制 4 份数据以实现无缝循环，由 Vue 统一管理 -->
        <template v-for="loop in 4" :key="'loop-' + loop">
          <div v-for="building in buildings" :key="building.id + '-' + loop" class="build-card" :data-id="building.id"
            @mouseenter="handleCardMouseEnter" @mouseleave="handleCardMouseLeave">
            <img :src="building.coverImage || 'https://images.unsplash.com/photo-1541701494587-cb58502866ab?w=600'"
              draggable="false">
            <div class="build-info">{{ building.name }} - {{ building.subtitle }}</div>
          </div>
        </template>
      </div>
    </section>

    <section class="history-area reveal-section">
      <h2 style="text-align: center; margin-bottom: 60px;">小镇编年史</h2>
      <div class="timeline">
        <div v-for="chronicle in chronicles" :key="chronicle.id" class="history-item">
          <h3>{{ chronicle.date }} | {{ chronicle.title }}</h3>
          <p>{{ chronicle.content }}</p>
        </div>
      </div>
    </section>

    <section class="server-info reveal-section">
      <div class="server-info-inner">
        <div class="server-info-left">
          <a class="server-logo-link" href="https://www.yuque.com/guangsu-fbxum/vpmkb2" target="_blank"
            rel="noopener noreferrer" title="点击进入官网">
            <img class="server-logo-img"
              src="https://mosicong.oss-cn-guangzhou.aliyuncs.com/img/%E5%83%8F%E7%B4%A0%E4%B9%8B%E6%A2%A6.jpg"
              alt="像素之梦" />
          </a>
          <button class="server-website-btn"
            onclick="window.open('https://www.yuque.com/guangsu-fbxum/vpmkb2','_blank')">
            进入官网
          </button>
        </div>

        <div class="server-info-right">
          <div class="server-info-title">
            <span class="server-info-name">像素之梦</span>
            <span class="server-info-status">ONLINE</span>
          </div>

          <div class="server-info-table">
            <div class="server-info-row">
              <span class="server-info-k">访问域名</span>
              <span class="server-info-v"><span class="server-info-mono">mc.recraft.cc</span></span>
            </div>
            <div class="server-info-row">
              <span class="server-info-k">版本范围</span>
              <span class="server-info-v">
                1.9.X-1.20.X
                <span class="server-info-note">（推荐 1.19.4 客户端）</span>
              </span>
            </div>
            <div class="server-info-row">
              <span class="server-info-k">QQ群</span>
              <span class="server-info-v">
                <span class="server-info-qq">通知群：<span class="server-info-mono">316978727</span></span>
                <span class="server-info-split">|</span>
                <span class="server-info-qq">闲聊群：<span class="server-info-mono">958233227</span></span>
              </span>
            </div>
          </div>

          <div class="server-info-slogan">
            快 来 像 素 之 梦 ，加 入 我 们 吧 ！
          </div>
        </div>
      </div>
    </section>

    <section class="pv-strip reveal-section">
      <div class="pv-panel">
        <div class="pv-left">
          <div class="pv-title">浏览量</div>
          <div class="pv-sub">REDSTONE TRAFFIC COUNTER</div>
        </div>
        <div class="pv-right">
          <div class="pv-count">
            <span class="pv-count-label">TOTAL</span>
            <span class="pv-count-value">{{ pageViewTotalDisplay }}</span>
          </div>
          <div class="pv-meta">
            <div class="pv-meta-item">LAST: <span>{{ pageViewLastTimeDisplay }}</span></div>
            <div class="pv-meta-item">STATUS: <span>{{ pageViewStatusDisplay }}</span></div>
          </div>
        </div>
      </div>
    </section>

    <footer>
      <p>YunBianTown V{{ latestVersion }} © 2026. <br><br>The YunBian town is looking forward to your joining!</p>
    </footer>

    <div id="mcModal" class="mc-modal" :class="{ active: modalActive }">
      <h3 id="modalTitle" style="color: #000; margin: 0; font-size: 14px;">{{ modalTitle }}</h3>
      <input type="text" id="modalInput" v-model="modalInput" placeholder="输入公告内容或地理坐标名称...">
      <div class="modal-btns" style="display:flex; gap:10px;">
        <button class="mc-btn" @click="closeModal()">撤销操作</button>
        <button class="mc-btn mc-btn-primary" @click="confirmModal()">记录档案</button>
      </div>
    </div>
    <div id="toast" :class="{ active: toastActive }">{{ toastMessage }}</div>

    <!-- 邮件反馈弹窗 -->
    <div class="mail-modal-overlay" v-if="mailModalActive" :class="{ closing: mailModalClosing }">
      <div class="mc-mail-card" :class="{ shake: mailShake, closing: mailModalClosing }" @click.stop>
        <div class="mc-mail-header">
          <div class="mc-mail-title">给小葱投信</div>
          <div class="mc-close-btn" @click="closeMailModal">×</div>
        </div>
        <div class="mc-mail-body">
          <!-- 昵称与邮箱 (仅游客显示) -->
          <div class="form-row" v-if="!userLoggedIn">
            <div class="form-item" :class="{ 'error-border': mailFieldError.nickname }">
              <label>游戏昵称 <span class="required-star">*</span></label>
              <input type="text" v-model="mailForm.nickname" placeholder="游戏内ID" maxlength="20" @input="mailFieldError.nickname = false">
            </div>
            <div class="form-item" :class="{ 'error-border': mailFieldError.email }">
              <label>邮箱 (可选)</label>
              <input type="email" v-model="mailForm.email" placeholder="可以第一时间收到回信" maxlength="50" @input="mailFieldError.email = false">
            </div>
          </div>

          <!-- 验证码 (游客填写邮箱后显示) -->
          <div class="form-row" v-if="!userLoggedIn && mailForm.email && mailForm.email.trim() !== ''">
            <div class="form-item code-item" :class="{ 'error-border': mailFieldError.code }">
              <label>验证码 <span class="required-star">*</span></label>
              <div class="code-input-group">
                <input type="text" v-model="mailForm.code" placeholder="4位验证码" maxlength="4" @input="mailFieldError.code = false">
                <button class="mc-mini-btn" :disabled="isSendingCode || codeTimer > 0" @click="sendEmailCode">
                  {{ isSendingCode ? '发送中...' : (codeTimer > 0 ? codeTimer + 's' : '发送') }}
                </button>
              </div>
            </div>
          </div>

          <!-- 反馈类型 -->
          <div class="form-row">
            <div class="form-item" :class="{ 'error-border': mailFieldError.type }">
              <label>反馈类型 <span class="required-star">*</span></label>
              <div class="mc-custom-select" :class="{ open: showTypeDropdown }" v-click-outside="closeTypeDropdown">
                <div class="mc-select-trigger" @click="toggleTypeDropdown">
                  <span :class="{ 'placeholder': !mailForm.type }">
                    {{ getTypeText(mailForm.type) || '请选择反馈类型' }}
                  </span>
                  <div class="mc-select-arrow"></div>
                </div>
                <div class="mc-select-options" :class="{ visible: showTypeDropdown }">
                  <transition-group name="mc-stagger" tag="div" class="mc-options-inner">
                    <div
                      v-for="(t, idx) in mailTypesDisplay"
                      :key="t.value"
                      class="mc-option"
                      :style="{ transitionDelay: (showTypeDropdown ? (idx * 40) : ((mailTypes.length - 1 - idx) * 30)) + 'ms' }"
                      @click="selectMailType(t.value)"
                    >
                      {{ t.label }}
                    </div>
                  </transition-group>
                </div>
              </div>
            </div>
            <div class="form-item" v-if="mailForm.type === 'custom'" :class="{ 'error-border': mailFieldError.customType }">
              <label>自定义类型 ({{ mailForm.customType.length }}/15) <span class="required-star">*</span></label>
              <input type="text" v-model="mailForm.customType" placeholder="请输入类型名称..." maxlength="15" @input="mailFieldError.customType = false">
            </div>
          </div>

          <!-- 反馈内容 -->
          <div class="form-item content-item" :class="{ 'error-border': mailFieldError.content }">
            <label>反馈内容 ({{ mailForm.content.length }}/500) <span class="required-star">*</span></label>
            <textarea v-model="mailForm.content" placeholder="请在这里详细描述您的问题或建议..." maxlength="500" @input="mailFieldError.content = false"></textarea>
          </div>
        </div>
        <div class="mc-mail-footer">
          <button class="mc-btn mc-btn-primary full-width" :disabled="isSubmittingMail" @click="submitMail">
            <template v-if="isSubmittingMail">
              <span class="loading-spinner"></span> 正在投递...
            </template>
            <template v-else>
              投递邮件
            </template>
          </button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick, computed } from 'vue'
import { useRouter } from 'vue-router'
import { API_BASE } from '../config/apiBase'
import { isTokenValid, syncUserSession } from '../utils/auth.js'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

const clickOutside = {
  beforeMount(el, binding) {
    el.__clickOutsideHandler__ = (e) => {
      if (el === e.target || el.contains(e.target)) return
      if (typeof binding.value === 'function') binding.value(e)
    }
    document.addEventListener('mousedown', el.__clickOutsideHandler__)
    document.addEventListener('touchstart', el.__clickOutsideHandler__)
  },
  unmounted(el) {
    document.removeEventListener('mousedown', el.__clickOutsideHandler__)
    document.removeEventListener('touchstart', el.__clickOutsideHandler__)
    el.__clickOutsideHandler__ = null
  }
}

export default {
  name: 'IndexPage',
  directives: {
    'click-outside': clickOutside
  },
  setup() {
    const router = useRouter()

    const DEFAULT_STEVE = 'https://minotar.net/avatar/steve/64'
    const userProfile = ref({})

    const loadUserProfile = () => {
      if (!syncUserSession()) {
        userProfile.value = {}
        return
      }
      try {
        const raw = localStorage.getItem('user_profile')
        userProfile.value = raw ? JSON.parse(raw) : {}
      } catch (e) {
        userProfile.value = {}
      }
    }

    const userLoggedIn = computed(() => isTokenValid('user_token'))

    const userNickname = computed(() => {
      return (userProfile.value && userProfile.value.nickname) || '玩家'
    })

    const userAvatar = computed(() => {
      const u = userProfile.value && userProfile.value.avatarUrl ? String(userProfile.value.avatarUrl).trim() : ''
      return u ? u : DEFAULT_STEVE
    })

    const DESIGN_WIDTH = 1440
    const enableMobileScale = ref(false)
    const mobileScaleStyle = ref({})

    const updateMobileScale = () => {
      const w = window.innerWidth || document.documentElement.clientWidth || DESIGN_WIDTH
      const isMobile = w <= 1024
      enableMobileScale.value = isMobile

      if (!isMobile) {
        mobileScaleStyle.value = {}
        return
      }

      const scale = Math.min(1, w / DESIGN_WIDTH)
      mobileScaleStyle.value = {
        width: DESIGN_WIDTH + 'px',
        transform: `scale(${scale})`,
        transformOrigin: 'top left'
      }

      document.documentElement.style.setProperty('--mobile-scale', String(scale))
    }

    const mailboxHover = ref(false)
    const unreadMailCount = ref(0)
    const mailModalActive = ref(false)
    const mailModalClosing = ref(false)
    const isSubmittingMail = ref(false)
    const mailForm = ref({
      nickname: '',
      email: '',
      code: '',
      type: '',
      customType: '',
      content: ''
    })
    const mailFieldError = ref({
      nickname: false,
      email: false,
      code: false,
      type: false,
      customType: false,
      content: false
    })
    const mailShake = ref(false)
    const isSendingCode = ref(false)
    const codeTimer = ref(0)
    const showTypeDropdown = ref(false)

    const toggleTypeDropdown = () => {
      showTypeDropdown.value = !showTypeDropdown.value
    }

    const closeTypeDropdown = () => {
      showTypeDropdown.value = false
    }

    const selectMailType = (val) => {
      mailForm.value.type = val
      mailFieldError.value.type = false
      showTypeDropdown.value = false
    }

    const mailTypes = [
      { value: 'build', label: '小镇建设意见' },
      { value: 'report', label: '小镇破坏举报' },
      { value: 'join', label: '想要加入小镇' },
      { value: 'chat', label: '随便聊聊' },
      { value: 'bug', label: '网页bug反馈' },
      { value: 'custom', label: '自定义' }
    ]

    const getTypeText = (val) => {
      if (!val) return ''
      const type = mailTypes.find(t => t.value === val)
      return type ? type.label : ''
    }

    const mailTypesDisplay = computed(() => {
      return showTypeDropdown.value ? mailTypes : []
    })

    const openMailModal = () => {
      mailModalClosing.value = false
      if (userLoggedIn.value) {
        mailForm.value.nickname = userNickname.value
        mailForm.value.email = userProfile.value.email || ''
      }
      mailModalActive.value = true
    }

    const closeMailModal = () => {
      if (!mailModalActive.value || mailModalClosing.value) return
      mailModalClosing.value = true
      setTimeout(() => {
        mailModalActive.value = false
        mailModalClosing.value = false
      }, 220)
    }

    const handleMailboxClick = () => {
      openMailModal()
    }

    const sendEmailCode = async () => {
      if (!mailForm.value.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mailForm.value.email)) {
        showToast('请输入有效的邮箱地址', 3000)
        return
      }
      isSendingCode.value = true
      try {
        const res = await fetch(`${API_BASE}/api/mail/send-code?email=${mailForm.value.email}`, { method: 'POST' })
        const data = await res.json()
        if (data.code === 200) {
          showToast('验证码已发送至您的邮箱', 3000)
          codeTimer.value = 60
          const timer = setInterval(() => {
            codeTimer.value--
            if (codeTimer.value <= 0) clearInterval(timer)
          }, 1000)
        } else {
          showToast(data.msg || '发送失败，请检查邮箱是否正确', 3000)
        }
      } catch (e) {
        showToast('发送失败，请检查邮箱是否正确', 3000)
      } finally {
        isSendingCode.value = false
      }
    }

    const triggerMailShake = () => {
      mailShake.value = false
      nextTick(() => {
        mailShake.value = true
        setTimeout(() => {
          mailShake.value = false
        }, 420)
      })
    }

    const submitMail = async () => {
      // 重置错误态
      mailFieldError.value = {
        nickname: false,
        email: false,
        code: false,
        type: false,
        customType: false,
        content: false
      }

      // 基础校验
      if (!userLoggedIn.value) {
        if (!mailForm.value.nickname || !String(mailForm.value.nickname).trim()) {
          mailFieldError.value.nickname = true
        }
        const email = String(mailForm.value.email || '').trim()
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          mailFieldError.value.email = true
        }
        if (email && (!mailForm.value.code || String(mailForm.value.code).trim().length !== 4)) {
          mailFieldError.value.code = true
        }
      }

      if (!mailForm.value.type) {
        mailFieldError.value.type = true
      }
      if (mailForm.value.type === 'custom' && (!mailForm.value.customType || !String(mailForm.value.customType).trim())) {
        mailFieldError.value.customType = true
      }
      if (!mailForm.value.content || !String(mailForm.value.content).trim() || mailForm.value.content.length > 500) {
        mailFieldError.value.content = true
      }

      const hasError = Object.values(mailFieldError.value).some(Boolean)
      if (hasError) {
        showToast('请完善必填项后再提交', 3000)
        triggerMailShake()
        return
      }

      isSubmittingMail.value = true
      try {
        const token = localStorage.getItem('user_token')
        const headers = { 'Content-Type': 'application/json' }
        if (token) {
          headers.Authorization = `Bearer ${token}`
        }

        const res = await fetch(`${API_BASE}/api/mail/submit`, {
          method: 'POST',
          headers,
          body: JSON.stringify(mailForm.value)
        })
        const data = await res.json()
        if (data.code === 200) {
          showToast('提交成功，感谢您的反馈！', 3000)
          closeMailModal()

          // 投递成功后清空表单，确保下次打开是空表单
          mailForm.value = {
            nickname: '',
            email: '',
            code: '',
            type: '',
            customType: '',
            content: ''
          }
          showTypeDropdown.value = false
          codeTimer.value = 0
        } else {
          showToast(data.msg || '提交失败', 3000)
          triggerMailShake()
        }
      } catch (e) {
        showToast('发送失败，请检查邮箱是否正确', 3000)
        triggerMailShake()
      } finally {
        isSubmittingMail.value = false
      }
    }

    const handleUserEntryClick = () => {
      if (userLoggedIn.value) {
        router.push('/me')
      } else {
        router.push('/login')
      }
    }

    const scrollHintOpacity = ref(1)
    const scrollHintBlur = ref(0)

    const computeScrollHintOpacity = () => {
      const target = document.querySelector('.hero-carousel-wrapper') || document.querySelector('.founder-strip')
      if (!target) {
        const y = window.scrollY || 0
        const max = Math.max(window.innerHeight * 0.9, 1)
        const p = Math.max(0, Math.min(1, y / max))
        scrollHintOpacity.value = 1 - p
        scrollHintBlur.value = Math.max(0, Math.min(10, p * 10))
        return
      }

      const targetTop = target.getBoundingClientRect().top + (window.scrollY || 0)
      const y = window.scrollY || 0
      const max = Math.max(targetTop, 1)
      const p = Math.max(0, Math.min(1, y / max))
      scrollHintOpacity.value = 1 - p
      scrollHintBlur.value = Math.max(0, Math.min(10, p * 10))
    }

    const scrollToNext = () => {
      const el = document.querySelector('.hero-carousel-wrapper') || document.querySelector('.founder-strip')
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else {
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })
      }
    }
    const galleryTrack = ref(null)
    const avatarLink = ref(null)
    const isAvatarHovered = ref(false)
    const avatarTiltStyle = ref({ transform: '' })

    const handleAvatarMouseMove = (e) => {
      if (!avatarLink.value) return
      isAvatarHovered.value = true
      const rect = avatarLink.value.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top
      const centerX = rect.width / 2
      const centerY = rect.height / 2
      
      // 计算倾斜角度 (限制在 15 度以内)
      const rotateX = ((y - centerY) / centerY) * -15
      const rotateY = ((x - centerX) / centerX) * 15
      
      avatarTiltStyle.value = {
        transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.08, 1.08, 1.08)`
      }
    }

    const handleAvatarMouseLeave = () => {
      isAvatarHovered.value = false
      avatarTiltStyle.value = {
        transform: `perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)`
      }
    }

    const modalActive = ref(false)
    const toastActive = ref(false)
    const toastMessage = ref('')
    const modalTitle = ref('村务数据录入')
    const modalInput = ref('')
    const map = ref(null)

    // 数据状态
    const notices = ref([])
    const userNotices = ref([])
    const markers = ref([])
    const residents = ref([])
    const buildings = ref([])
    const chronicles = ref([])

    // 轮播图数据（后端 /api/carousels）
    const carousels = ref([])
    const carouselsReady = ref(false)
    const carouselImagesLoaded = ref(false)
    const currentCarouselIndex = ref(0)
    let carouselInterval = null

    // 浏览量（首页）
    const pageViewTotal = ref(0)
    const pageViewLastTime = ref('')
    const latestVersion = ref('1.0.0')

    const loadLatestVersion = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/update-logs`)
        const json = await res.json()
        if (json.code === 200 && Array.isArray(json.data) && json.data.length > 0) {
          // 直接从列表取第一条作为最新版本
          latestVersion.value = json.data[0].version
        }
      } catch (e) {
        console.error('Failed to load version:', e)
      }
    }
    const pageViewTotalDisplay = computed(() => {
      const n = Number(pageViewTotal.value || 0)
      return n.toLocaleString('en-US')
    })
    const pageViewLastTimeDisplay = computed(() => {
      return pageViewLastTime.value ? String(pageViewLastTime.value) : '--'
    })
    const pageViewStatusDisplay = computed(() => {
      const t = String(pageViewTotal.value || 0)
      return `REDSTONE OK · SEED ${t.padStart(4, '0')}`
    })



    // API_BASE moved to @/config/apiBase

    const x = ref(0)
    const speed = ref(1.2)
    const baseSpeed = 1.2
    const isPaused = ref(false)
    const isDragging = ref(false)
    const startX = ref(0)
    const scrollX = ref(0)
    const lastMoveX = ref(0)
    const lastMoveTime = ref(0)
    const velocity = ref(0)
    const isDecelerating = ref(false)
    const dragDistance = ref(0)
    const decelerationStartTime = ref(0)
    const decelerationStartSpeed = ref(0)
    const peakSpeed = ref(0) // 峰值速度（加速阶段的目标）
    const targetSpeed = ref(baseSpeed) // 最终目标速度，根据拖动方向决定
    const isAccelerating = ref(false) // 是否在加速阶段
    const isStopping = ref(false) // 是否在减速停止阶段
    const stoppingStartTime = ref(0) // 停止开始时间
    const stoppingStartSpeed = ref(0) // 停止开始时的速度
    let scrollLoopId = null

    const goToBuilding = (id) => {
      router.push(`/building/${id}`)
    }

    const handleGalleryClick = (e) => {
      // 如果拖动距离大于5px，认为是拖动而不是点击
      if (dragDistance.value > 5) {
        return
      }
      
      // 通过事件冒泡找到被点击的卡片
      const card = e.target.closest('.build-card')
      if (card) {
        const id = card.getAttribute('data-id')
        if (id) {
          goToBuilding(id)
        }
      }
    }

    let toastTimer = null

    const showToast = (message, duration = 3000) => {
      toastMessage.value = message
      toastActive.value = true

      if (toastTimer) {
        clearTimeout(toastTimer)
      }

      toastTimer = setTimeout(() => {
        toastActive.value = false
        toastTimer = null
      }, duration)
    }

    const tapSign = (name) => {
      showToast(`👋 [ ${name} ] 成功接收到了你的拜访信号！`, 3000)
    }

    const openModal = () => {
      // 首页禁用添加功能，提示前往后台管理
      showToast('请前往后台管理页面 (/set) 进行管理操作', 3000)
      return
    }

    const closeModal = () => {
      modalActive.value = false
    }

    const confirmModal = () => {
      // 首页禁用添加功能
      closeModal()
    }

    const parseDate = (d) => {
      if (!d) return Number.MAX_SAFE_INTEGER;
      return new Date(d.replace(/\./g, '-')).getTime();
    };
    // 加载数据
    const recordPageView = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/page-views/record?path=/index`)
        const json = await res.json()
        if (json && json.code === 200 && json.data) {
          pageViewTotal.value = json.data.total || 0
          pageViewLastTime.value = json.data.lastTime ? json.data.lastTime : ''
        }
      } catch (e) {
        // ignore
      }
    }

    const getNameFitStyle = (name) => {
      if (!name) return {}
      const len = name.length
      // 假设 8 个字符以内不缩放，超过 8 个字符开始按比例缩小，最小缩放到 0.6 倍
      if (len > 8) {
        const scale = Math.max(0.6, 8 / len)
        return {
          transform: `scale(${scale})`,
          whiteSpace: 'nowrap'
        }
      }
      return {}
    }

    const loadData = async () => {
      try {
        // 加载公告（管理员公告）
        const noticesRes = await fetch(`${API_BASE}/api/notices`)
        const noticesData = await noticesRes.json()
        if (noticesData.code === 200) {
          // 排序逻辑：置顶(top)权重最高，自定义类型权重第二，其他按原逻辑
          const priority = { top: 3, normal: 0, security: 1, infrastructure: 1 }
          notices.value = (noticesData.data || []).slice().sort((a, b) => {
            const weightA = priority[a.type] !== undefined ? priority[a.type] : 2
            const weightB = priority[b.type] !== undefined ? priority[b.type] : 2
            return weightB - weightA
          })
        }

        // 加载公告（玩家公告）
        const userNoticesRes = await fetch(`${API_BASE}/api/user-notices`)
        const userNoticesData = await userNoticesRes.json()
        if (userNoticesData.code === 200) {
          // 按照发送时间升序排列（最早的在最上面）
          userNotices.value = (userNoticesData.data || []).slice().sort((a, b) => {
            const timeA = a.createdAt ? new Date(a.createdAt).getTime() : 0
            const timeB = b.createdAt ? new Date(b.createdAt).getTime() : 0
            return timeA - timeB
          })
        }

        // 加载标点
        const markersRes = await fetch(`${API_BASE}/api/markers`)
        const markersData = await markersRes.json()
        if (markersData.code === 200) {
          markers.value = markersData.data
        }

        // 加载居民
        const residentsRes = await fetch(`${API_BASE}/api/residents`)
        const residentsData = await residentsRes.json()
        if (residentsData.code === 200) {
          residents.value = residentsData.data
        }

        // 加载建筑
        const buildingsRes = await fetch(`${API_BASE}/api/buildings`)
        const buildingsData = await buildingsRes.json()
        if (buildingsData.code === 200) {
          buildings.value = (buildingsData.data || []).slice().sort((a, b) => parseDate(a.date) - parseDate(b.date))

        }

        // 加载编年史
        const chroniclesRes = await fetch(`${API_BASE}/api/chronicles`)
        const chroniclesData = await chroniclesRes.json()
        if (chroniclesData.code === 200) {
          chronicles.value = (chroniclesData.data || []).slice().sort((a, b) => parseDate(b.date) - parseDate(a.date))
        }

        // 加载轮播图（顶部轮播，来自 /api/carousels）
        const carouselsRes = await fetch(`${API_BASE}/api/carousels`)
        const carouselsData = await carouselsRes.json()
        if (carouselsData.code === 200) {
          // 只显示启用(isActive=1)的轮播图，并按 sortOrder 排序
          carousels.value = (carouselsData.data || [])
            .filter(c => c.isActive === 1)
            .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))

          // 预加载所有轮播图图片
          if (carousels.value.length > 0) {
            carouselsReady.value = false
            carouselImagesLoaded.value = false
            const imageUrls = carousels.value.map(c => c.imageUrl).filter(url => url)

            try {
              await preloadCarouselImages(imageUrls)
              carouselImagesLoaded.value = true
              console.log('轮播图图片预加载完成')
            } catch (error) {
              console.error('图片预加载出错:', error)
              // 即使预加载失败，也允许显示轮播图
              carouselImagesLoaded.value = true
            }

            // 强制在 DOM 更新后再展示轮播，避免“刷新太快 reveal-section 还没触发/容器尺寸未就绪”
            await nextTick()
            carouselsReady.value = true

            // 启动自动轮播
            if (carousels.value.length > 1) {
              startCarouselAutoPlay()
            }

            // 确保轮播图在数据加载后立即显示
            nextTick(() => {
              const carouselWrapper = document.querySelector('.hero-carousel-wrapper')
              if (carouselWrapper) {
                const rect = carouselWrapper.getBoundingClientRect()
                const isInViewport = rect.top < window.innerHeight && rect.bottom > 0
                if (isInViewport) {
                  carouselWrapper.classList.add('is-visible')
                }
              }
            })
          } else {
            carouselsReady.value = false
          }
        }
      } catch (error) {
        console.error('加载数据失败:', error)
      }
    }

    // 预加载轮播图图片（带重试机制）
    const preloadCarouselImages = (imageUrls) => {
      return Promise.all(
        imageUrls.map((url) => {
          return new Promise((resolve) => {
            let retryCount = 0
            const maxRetries = 2

            const loadImage = (imageUrl) => {
              return new Promise((resolveLoad) => {
                const img = new Image()
                let isResolved = false

                // 设置超时，避免长时间等待
                const timeout = setTimeout(() => {
                  if (!isResolved && !img.complete) {
                    isResolved = true
                    console.warn(`图片加载超时: ${imageUrl}`)
                    resolveLoad({ success: false, url: imageUrl })
                  }
                }, 8000)

                img.onload = () => {
                  if (!isResolved) {
                    isResolved = true
                    clearTimeout(timeout)
                    console.log(`图片加载成功: ${imageUrl}`)
                    resolveLoad({ success: true, url: imageUrl })
                  }
                }

                img.onerror = () => {
                  if (!isResolved) {
                    isResolved = true
                    clearTimeout(timeout)
                    console.warn(`图片加载失败: ${imageUrl}, 重试次数: ${retryCount}`)
                    resolveLoad({ success: false, url: imageUrl })
                  }
                }

                // 添加时间戳防止缓存问题
                const separator = imageUrl.includes('?') ? '&' : '?'
                img.src = imageUrl + separator + '_t=' + Date.now()
              })
            }

            const attemptLoad = async () => {
              const result = await loadImage(url)
              if (!result.success && retryCount < maxRetries) {
                retryCount++
                console.log(`重试加载图片 (${retryCount}/${maxRetries}): ${url}`)
                await new Promise(resolve => setTimeout(resolve, 1000)) // 等待1秒后重试
                return attemptLoad()
              }
              resolve(result)
            }

            attemptLoad()
          })
        })
      )
    }

    const startCarouselAutoPlay = () => {
      if (carouselInterval) {
        clearInterval(carouselInterval)
      }
      carouselInterval = setInterval(() => {
        if (carousels.value.length > 1 && carouselImagesLoaded.value) {
          currentCarouselIndex.value = (currentCarouselIndex.value + 1) % carousels.value.length
        }
      }, 4000) // 每4秒切换
    }



    const getTypeName = (type) => {
      const map = { top: '置顶', security: '安全', infrastructure: '基建', normal: '普通' }
      return map[type] || type || '普通'
    }

    const scrollLoop = () => {
      // 在拖动、加速、减速、停止阶段，强制不暂停（禁用悬停停止）
      const shouldPause = isPaused.value && !isDragging.value && !isAccelerating.value && !isDecelerating.value && !isStopping.value

      if (!shouldPause && !isDragging.value) {
        if (isStopping.value) {
          // 停止阶段：从当前速度减速到0
          x.value -= speed.value

          const elapsed = Date.now() - stoppingStartTime.value
          const stopDuration = 400 // 停止持续时间
          const progress = Math.min(elapsed / stopDuration, 1)

          // 使用 ease-out 缓动，平滑减速到0
          const eased = 1 - Math.pow(1 - progress, 2.5)
          speed.value = stoppingStartSpeed.value * (1 - eased)

          // 当速度接近0时，完全停止
          if (progress >= 1 || Math.abs(speed.value) < 0.05) {
            speed.value = 0
            isStopping.value = false
            // 停止完成，现在可以保持暂停状态
          }
        } else if (isAccelerating.value || isDecelerating.value) {
          x.value -= speed.value

          const elapsed = Date.now() - decelerationStartTime.value

          if (isAccelerating.value) {
            // 加速阶段：从当前速度加速到峰值速度
            const accelerationDuration = 200 // 加速持续时间（很短，立刻加速）
            const progress = Math.min(elapsed / accelerationDuration, 1)

            // 使用 ease-out 缓动，快速加速
            const eased = 1 - Math.pow(1 - progress, 3)
            speed.value = decelerationStartSpeed.value + (peakSpeed.value - decelerationStartSpeed.value) * eased

            // 当达到峰值速度时，进入减速阶段
            if (progress >= 1 || Math.abs(speed.value - peakSpeed.value) < 0.1) {
              speed.value = peakSpeed.value
              isAccelerating.value = false
              isDecelerating.value = true
              // 重置时间，开始减速阶段
              decelerationStartTime.value = Date.now()
              decelerationStartSpeed.value = peakSpeed.value
            }
          } else if (isDecelerating.value) {
            // 减速阶段：从峰值速度逐渐减速到目标速度
            const decelerationDuration = 1500 // 减速持续时间
            const progress = Math.min(elapsed / decelerationDuration, 1)

            const startSpeed = decelerationStartSpeed.value
            const endSpeed = targetSpeed.value

            // 判断是否需要经过0点（方向反转）
            const needsReversal = (startSpeed > 0 && endSpeed < 0) || (startSpeed < 0 && endSpeed > 0)

            if (needsReversal) {
              // 需要经过0点，分两段处理
              const absStart = Math.abs(startSpeed)
              const absEnd = Math.abs(endSpeed)
              const zeroPoint = absStart / (absStart + absEnd)

              if (progress < zeroPoint) {
                // 第一阶段：减速到0
                const firstProgress = progress / zeroPoint
                const eased = 1 - Math.pow(1 - firstProgress, 2.5)
                speed.value = startSpeed * (1 - eased)
              } else {
                // 第二阶段：从0加速到目标速度
                const secondProgress = (progress - zeroPoint) / (1 - zeroPoint)
                const eased = secondProgress < 0.5
                  ? 2 * secondProgress * secondProgress
                  : 1 - Math.pow(-2 * secondProgress + 2, 2) / 2
                speed.value = endSpeed * eased
              }
            } else {
              // 不需要经过0点，直接衰减
              // 使用 ease-out 缓动，更自然
              const eased = 1 - Math.pow(1 - progress, 2.5)
              speed.value = startSpeed + (endSpeed - startSpeed) * eased
            }

            // 当速度接近目标速度时，切换到匀速
            if (progress >= 1 || Math.abs(speed.value - endSpeed) < 0.05) {
              speed.value = endSpeed
              isDecelerating.value = false
              // 减速完成，现在可以启用悬停暂停功能了
              // 如果鼠标正在悬停，现在可以暂停
              if (isPaused.value) {
                // 保持暂停状态
              }
            }
          }
        } else {
          // 匀速阶段
          x.value -= speed.value
        }

        if (galleryTrack.value) {
          const trackWidth = galleryTrack.value.scrollWidth
          const originalWidth = trackWidth / 4 // 因为复制了3次，所以原始宽度是1/4

          // 使用模运算实现无缝循环，避免跳跃
          // 当滚动超过原始宽度时，重置位置
          if (x.value <= -originalWidth) {
            x.value += originalWidth
          } else if (x.value >= 0) {
            x.value -= originalWidth
          }
          galleryTrack.value.style.transform = `translateX(${x.value}px)`
        }
      }
      scrollLoopId = requestAnimationFrame(scrollLoop)
    }

    const handleCardMouseEnter = () => {
      // 只有在匀速阶段（不在拖动、加速、减速、停止阶段）才允许暂停
      if (!isDragging.value && !isAccelerating.value && !isDecelerating.value && !isStopping.value) {
        // 开始减速停止
        isStopping.value = true
        isPaused.value = true
        stoppingStartTime.value = Date.now()
        stoppingStartSpeed.value = speed.value
      }
    }

    const handleCardMouseLeave = () => {
      // 如果正在停止，取消停止并恢复滚动
      if (isStopping.value) {
        isStopping.value = false
        isPaused.value = false
        // 从当前速度恢复到目标速度（如果有）或基础速度
        const currentSpeed = speed.value
        // 根据之前的目标速度恢复，如果没有则使用基础速度
        const resumeSpeed = targetSpeed.value || baseSpeed

        // 如果当前速度很小（接近0），从0加速到目标速度
        if (Math.abs(currentSpeed) < 0.1) {
          decelerationStartTime.value = Date.now()
          decelerationStartSpeed.value = 0
          targetSpeed.value = resumeSpeed
          isAccelerating.value = true
          isDecelerating.value = false
        } else {
          // 否则从当前速度加速到目标速度
          decelerationStartTime.value = Date.now()
          decelerationStartSpeed.value = currentSpeed
          targetSpeed.value = resumeSpeed
          isAccelerating.value = true
          isDecelerating.value = false
        }
      } else {
        isPaused.value = false
        // 如果正在拖动、加速或减速，不要重置速度
        if (!isDragging.value && !isAccelerating.value && !isDecelerating.value) {
          speed.value = baseSpeed
          targetSpeed.value = baseSpeed
          isAccelerating.value = false
          isDecelerating.value = false
        }
      }
    }

    const handleMouseDown = (e) => {
      e.preventDefault() // 阻止默认行为，防止文本选择
      isDragging.value = true
      isAccelerating.value = false
      isDecelerating.value = false
      isPaused.value = false // 拖动时强制取消暂停
      startX.value = e.pageX
      scrollX.value = x.value
      lastMoveX.value = e.pageX
      lastMoveTime.value = Date.now()
      velocity.value = 0
      dragDistance.value = 0 // 重置拖动距离
    }

    const handleMouseMove = (e) => {
      if (!isDragging.value) return
      e.preventDefault() // 阻止默认行为，防止文本选择
      const diff = e.pageX - startX.value
      x.value = scrollX.value + diff

      // 记录拖动距离
      dragDistance.value = Math.abs(diff)

      // 计算拖动速度（像素/毫秒）
      const now = Date.now()
      const timeDelta = now - lastMoveTime.value
      if (timeDelta > 0) {
        const moveDelta = e.pageX - lastMoveX.value
        velocity.value = moveDelta / timeDelta
      }
      lastMoveX.value = e.pageX
      lastMoveTime.value = now

      if (galleryTrack.value) {
        const trackWidth = galleryTrack.value.scrollWidth
        const originalWidth = trackWidth / 4 // 因为复制了3次，所以原始宽度是1/4

        // 在拖动时也处理循环，确保无缝
        // 当向左拖动（x.value 变负）超过原始宽度时，重置位置
        if (x.value <= -originalWidth) {
          x.value += originalWidth
          scrollX.value = x.value
          startX.value = e.pageX
        }
        // 当向右拖动（x.value 变正）超过0时，重置位置
        else if (x.value >= 0) {
          x.value -= originalWidth
          scrollX.value = x.value
          startX.value = e.pageX
        }

        galleryTrack.value.style.transform = `translateX(${x.value}px)`
      }
    }

    const handleMouseUp = () => {
      if (!isDragging.value) return
      isDragging.value = false

      // 根据拖动方向计算峰值速度和目标速度
      // velocity > 0 表示向右拖动（鼠标向右移动）
      // velocity < 0 表示向左拖动（鼠标向左移动）
      if (Math.abs(velocity.value) > 0.05) {
        // 向右拖动（velocity > 0）：图片应该向左移动（speed 为负值）
        // 向左拖动（velocity < 0）：图片应该向右移动（speed 为正值）
        // 将拖动速度转换为滚动速度（取反，因为拖动方向和滚动方向相反）
        const speedMultiplier = 1.2 // 调整这个值来控制拖动后的速度强度
        // 向右拖动时，velocity > 0，所以 peakSpeed = baseSpeed - 正数 = 负数（向左）
        // 向左拖动时，velocity < 0，所以 peakSpeed = baseSpeed - 负数 = 正数（向右）
        const calculatedPeakSpeed = baseSpeed - velocity.value * speedMultiplier

        // 限制峰值速度范围，允许负值（向左移动）
        peakSpeed.value = Math.max(-10, Math.min(10, calculatedPeakSpeed))

        // 根据拖动方向确定最终目标速度
        // 向右拖动（velocity > 0）：最终减速到向左匀速（-baseSpeed）
        // 向左拖动（velocity < 0）：最终减速到向右匀速（baseSpeed）
        if (velocity.value > 0.1) {
          // 向右拖动，最终向左匀速
          targetSpeed.value = -baseSpeed
        } else if (velocity.value < -0.1) {
          // 向左拖动，最终向右匀速
          targetSpeed.value = baseSpeed
        } else {
          // 速度很小，保持当前方向或回到默认
          if (peakSpeed.value < 0) {
            targetSpeed.value = -baseSpeed
          } else {
            targetSpeed.value = baseSpeed
          }
        }

        // 记录当前速度作为加速的起点
        // 拖动时速度通常是 baseSpeed（因为暂停了），但为了更自然，我们从接近0的速度开始加速
        const currentSpeed = isPaused.value ? baseSpeed : speed.value
        // 如果当前速度和峰值速度方向相同，从当前速度开始；否则从接近0开始
        const startSpeed = (currentSpeed * peakSpeed.value >= 0) ? currentSpeed : (peakSpeed.value > 0 ? 0.1 : -0.1)
        decelerationStartSpeed.value = startSpeed
        speed.value = startSpeed // 立即设置当前速度

        // 记录开始时间
        decelerationStartTime.value = Date.now()

        // 先进入加速阶段，加速到峰值速度
        isAccelerating.value = true
        isDecelerating.value = false
        isPaused.value = false // 加速/减速阶段强制取消暂停
      } else {
        // 如果没有明显拖动，直接恢复基础速度（向右匀速）
        speed.value = baseSpeed
        targetSpeed.value = baseSpeed
        isAccelerating.value = false
        isDecelerating.value = false
      }
    }

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        loadUserProfile()
        loadData()
      }
    }

    const maybeRefreshAfterPublish = () => {
      try {
        const flag = sessionStorage.getItem('refresh_buildings')
        if (flag === '1') {
          sessionStorage.removeItem('refresh_buildings')
          loadData()
        }
      } catch (e) {
        // ignore
      }
    }

    const onStorage = (e) => {
      if (!e) return
      if (e.key === 'user_profile' || e.key === 'user_token') {
        loadUserProfile()
      }
    }

    onMounted(() => {
      updateMobileScale()
      window.addEventListener('resize', updateMobileScale, { passive: true })

      window.addEventListener('visibilitychange', onVisibilityChange)
      window.addEventListener('storage', onStorage)
      window.addEventListener('scroll', computeScrollHintOpacity, { passive: true })
      nextTick(() => computeScrollHintOpacity())

      // 从发布页/详情页返回时，若设置了刷新标记则刷新一次数据
      maybeRefreshAfterPublish()

      // Intersection Observer
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible')
            } else {
              entry.target.classList.remove('is-visible')
            }
          })
        },
        { threshold: 0.1 }
      )

      const observeRevealSections = () => {
        document.querySelectorAll('.reveal-section').forEach((el) => {
          obs.observe(el)
          // 如果元素已经在视口中，立即显示（特别是轮播图在页面顶部）
          const rect = el.getBoundingClientRect()
          const isInViewport = rect.top < window.innerHeight && rect.bottom > 0
          if (isInViewport) {
            el.classList.add('is-visible')
          }
        })
      }

      // 首次绑定
      observeRevealSections()

      // 轮播图节点是异步 v-if 挂载的：用 MutationObserver 确保新插入的 reveal-section 也会被 observe
      const mo = new MutationObserver(() => {
        observeRevealSections()
      })
      mo.observe(document.body, { childList: true, subtree: true })

      // 清理
      onUnmounted(() => {
        window.removeEventListener('resize', updateMobileScale)
        window.removeEventListener('visibilitychange', onVisibilityChange)
        window.removeEventListener('storage', onStorage)

        if (typeof mo !== 'undefined' && mo) {
          mo.disconnect()
        }
      })

      // Leaflet Map
      nextTick(() => {
        const mapElement = document.getElementById('town-map')
        if (!mapElement) return

        // 检查地图是否已经初始化
        if (mapElement._leaflet_id) {
          // 如果已经初始化，先移除旧地图
          if (map.value) {
            map.value.remove()
          }
          // 清理容器
          mapElement._leaflet_id = null
          mapElement.innerHTML = ''
        }

        map.value = L.map('town-map', {
          crs: L.CRS.Simple,
          minZoom: -2,
          maxZoom: 2,
          scrollWheelZoom: false,
          touchZoom: false,
          attributionControl: false
        })

        const loadMapUrl = async () => {
          try {
            const res = await fetch(`${API_BASE}/api/map-config`)
            const data = await res.json()
            if (data.code === 200 && data.data && data.data.mapUrl) {
              return data.data.mapUrl
            }
          } catch (e) {
            // ignore
          }
          return 'https://images.unsplash.com/photo-1541701494587-cb58502866ab?auto=format&fit=crop&w=2000&q=80'
        }

        const getImageSize = (src) =>
          new Promise((resolve, reject) => {
            const img = new Image()
            img.onload = () => resolve({ width: img.naturalWidth || img.width, height: img.naturalHeight || img.height })
            img.onerror = reject
            img.src = src
          })

        loadMapUrl().then(async (rawUrl) => {
          const url = rawUrl && rawUrl.startsWith('http') ? `${API_BASE}/api/map-proxy?url=${encodeURIComponent(rawUrl)}` : rawUrl

          let size
          try {
            size = await getImageSize(url)
          } catch (e) {
            // fallback: 如果图片尺寸获取失败，退化使用旧 bounds
            size = { width: 1500, height: 1000 }
          }

          const imgBounds = [[0, 0], [size.height, size.width]]

          L.imageOverlay(url, imgBounds).addTo(map.value)
          map.value.fitBounds(imgBounds, { animate: false })
          map.value.zoomIn(2, { animate: false })

          // 移动端/容器尺寸变化时：强制让 Leaflet 重新计算尺寸，避免地图只渲染一部分
          setTimeout(() => {
            try {
              map.value && map.value.invalidateSize(true)
            } catch (e) {
              // ignore
            }
          }, 60)
        })

        const getBanner = (l) => {
          return L.divIcon({
            className: 'mc-banner-marker',
            html: `<div class="mc-banner-flag"></div><div class="mc-banner-text">${l}</div>`,
            iconSize: [0, 0]
          })
        }

        // 加载标点后添加到地图
        const updateMapMarkers = () => {
          if (!map.value) return
          markers.value.forEach((marker) => {
            L.marker([marker.lat, marker.lng], { icon: getBanner(marker.name) }).addTo(map.value)
          })
        }

        // 延迟更新标点，等待数据加载
        setTimeout(updateMapMarkers, 500)

        map.value.on('zoomend', () => {
          document.documentElement.style.setProperty(
            '--map-scale',
            Math.pow(1.5, map.value.getZoom())
          )
        })
        // 首页禁用右键添加标点功能
        // map.value.on('contextmenu', (e) => {
        //   openModal('map', e.latlng)
        // })
      })

      // Gallery scroll - 延迟初始化，等待数据加载
      setTimeout(() => {
        nextTick(() => {
          if (galleryTrack.value && buildings.value.length > 0) {
            // 在整个 gallery 区域添加拖动事件监听
            const gallerySection = galleryTrack.value.closest('.building-gallery')
            if (gallerySection) {
              gallerySection.addEventListener('mousedown', handleMouseDown)
            } else {
              galleryTrack.value.addEventListener('mousedown', handleMouseDown)
            }

            // 为所有图片卡片添加鼠标进入/离开事件
            const allCards = galleryTrack.value.querySelectorAll('.build-card')
            allCards.forEach((card) => {
              card.addEventListener('mouseenter', handleCardMouseEnter)
              card.addEventListener('mouseleave', handleCardMouseLeave)
            })
          }
          scrollLoop()
        })
      }, 500)

      window.addEventListener('mousemove', handleMouseMove)
      window.addEventListener('mouseup', handleMouseUp)

      // 加载用户态
      loadUserProfile()

      // 加载数据
      loadData()
      // 记录首页浏览量
      recordPageView()
      // 加载最新版本号
      loadLatestVersion()
      
      // 加载未读邮件数量
      const fetchUnreadMail = async () => {
        try {
          const res = await fetch(`${API_BASE}/api/mail/unread-count`)
          const json = await res.json()
          if (json.code === 200) unreadMailCount.value = json.data.count
        } catch (e) { /* ignore */ }
      }
      fetchUnreadMail()
    })

    onUnmounted(() => {
      window.removeEventListener('visibilitychange', onVisibilityChange)
      window.removeEventListener('storage', onStorage)
      window.removeEventListener('scroll', computeScrollHintOpacity)

      if (carouselInterval) {
        clearInterval(carouselInterval)
      }
      if (scrollLoopId) {
        cancelAnimationFrame(scrollLoopId)
      }
      if (galleryTrack.value) {
        const gallerySection = galleryTrack.value.closest('.building-gallery')
        if (gallerySection) {
          gallerySection.removeEventListener('mousedown', handleMouseDown)
        } else {
          galleryTrack.value.removeEventListener('mousedown', handleMouseDown)
        }

        // 移除所有卡片的事件监听
        const allCards = galleryTrack.value.querySelectorAll('.build-card')
        allCards.forEach((card) => {
          card.removeEventListener('mouseenter', handleCardMouseEnter)
          card.removeEventListener('mouseleave', handleCardMouseLeave)
        })
      }
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
      if (map.value) {
        map.value.remove()
        map.value = null
      }
      // 清理地图容器的 Leaflet ID
      const mapElement = document.getElementById('town-map')
      if (mapElement && mapElement._leaflet_id) {
        mapElement._leaflet_id = null
        mapElement.innerHTML = ''
      }
    })

    return {
      enableMobileScale,
      mobileScaleStyle,
      galleryTrack,
      modalActive,
      toastActive,
      toastMessage,
      modalTitle,
      modalInput,
      notices,
      userNotices,
      markers,
      residents,
      buildings,
      chronicles,
      carousels,
      currentCarouselIndex,
      carouselsReady,
      getTypeName,
      goToBuilding,
      handleGalleryClick,
      handleCardMouseEnter,
      handleCardMouseLeave,
      tapSign,
      openModal,
      closeModal,
      confirmModal,
      userLoggedIn,
      userNickname,
      userAvatar,
      handleUserEntryClick,
      scrollToNext,
      scrollHintOpacity,
      scrollHintBlur,
      pageViewTotalDisplay,
      pageViewLastTimeDisplay,
      pageViewStatusDisplay,
      latestVersion,
      getNameFitStyle,
      avatarLink,
      isAvatarHovered,
      avatarTiltStyle,
      handleAvatarMouseMove,
      handleAvatarMouseLeave,
      // 暴露邮件相关变量和方法
      mailboxHover,
      unreadMailCount,
      mailModalActive,
      mailForm,
      isSendingCode,
      codeTimer,
      handleMailboxClick,
      sendEmailCode,
      submitMail,
      isSubmittingMail,
      mailFieldError,
      mailShake,
      mailModalClosing,
      openMailModal,
      closeMailModal,
      showTypeDropdown,
      toggleTypeDropdown,
      closeTypeDropdown,
      selectMailType,
      getTypeText,
      mailTypes,
      mailTypesDisplay
    }
  }
}
</script>

<style>
:root {
  --mc-oak: #c69c6d;
  --mc-oak-dark: #7d5a35;
  --mc-oak-text: #372511;
  --mc-green: #5ea818;
  --mc-bg: #121213;
  --mc-stone: #7a7a7a;
  --map-scale: 1;
}

/* 桌面端自定义光标 */
@media (min-width: 1025px) {
  * {
    cursor: url('https://cur.cursors-4u.net/games/gam-4/gam385.cur'), auto !important;
  }

  a,
  button,
  .oak-sign-box,
  .build-card,
  .user-entry {
    cursor: url('https://cur.cursors-4u.net/games/gam-4/gam384.cur'), pointer !important;
  }
}

body,
html {
  margin: 0;
  padding: 0;
  background-color: var(--mc-bg);
  font-family: 'Press Start 2P', 'Microsoft YaHei', cursive;
  color: white;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  width: 100%;
  box-sizing: border-box;
  -webkit-text-size-adjust: 100%;
}

html {
  scrollbar-gutter: stable;
  scrollbar-color: #5ea818 #0b0b0b;
}

/* Minecraft 风格滚动条（桌面端/Chromium/Edge/Safari） */
body::-webkit-scrollbar {
  width: 16px;
}

body::-webkit-scrollbar-track {
  background: linear-gradient(#0b0b0b, #111);
  border-left: 4px solid #000;
  box-shadow: inset 4px 0 0 rgba(255, 255, 255, 0.04);
}

body::-webkit-scrollbar-thumb {
  background:
    linear-gradient(90deg, #2f7d1b 0 25%, #3e8f27 25% 50%, #2f7d1b 50% 75%, #3e8f27 75% 100%);
  border: 4px solid #000;
  box-shadow: inset -3px -3px 0 rgba(0, 0, 0, 0.35), inset 3px 3px 0 rgba(255, 255, 255, 0.08);
}

body::-webkit-scrollbar-thumb:hover {
  background:
    linear-gradient(90deg, #3e8f27 0 25%, #59b13b 25% 50%, #3e8f27 50% 75%, #59b13b 75% 100%);
}

body::-webkit-scrollbar-thumb:active {
  background:
    linear-gradient(90deg, #245f14 0 25%, #2f7d1b 25% 50%, #245f14 50% 75%, #2f7d1b 75% 100%);
}

body::-webkit-scrollbar-button:single-button {
  display: block;
  height: 16px;
  width: 16px;
  background: #101010;
  border-left: 4px solid #000;
}

body::-webkit-scrollbar-button:single-button:vertical:decrement {
  background:
    linear-gradient(#101010, #0b0b0b),
    conic-gradient(from 225deg at 50% 60%, #9ae054 0 25%, transparent 0 100%);
}

body::-webkit-scrollbar-button:single-button:vertical:increment {
  background:
    linear-gradient(#101010, #0b0b0b),
    conic-gradient(from 45deg at 50% 40%, #9ae054 0 25%, transparent 0 100%);
}

* {
  box-sizing: border-box;
}

#app {
  width: 100%;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}

.page-container {
  width: 100%;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  position: relative;
}

.page-container.is-mobile-scale {
  overflow: hidden;
}

.page-container.is-mobile-scale .pc-scale-content {
  will-change: transform;
}

@media (max-width: 1024px) {
  .page-container.is-mobile-scale {
    width: calc(1440px * var(--mobile-scale, 1));
  }
}

.user-entry-bar {
  position: fixed;
  top: 18px;
  right: 18px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-mail-button {
  position: relative;
  height: 64px;
  width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: 4px solid #fff;
  background: rgba(0, 0, 0, 0.55);
  box-shadow: inset -3px -3px 0 rgba(0, 0, 0, 0.35), inset 3px 3px 0 rgba(255, 255, 255, 0.1);
  user-select: none;
}
.user-mail-button:hover {
  border-color: var(--mc-green);
  background: rgba(94, 168, 24, 0.25);
}

.user-entry {
  position: relative;
  height: 64px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: 4px solid #fff;
  background: rgba(0, 0, 0, 0.55);
  box-shadow: inset -3px -3px 0 rgba(0, 0, 0, 0.35), inset 3px 3px 0 rgba(255, 255, 255, 0.1);
  cursor: url('https://cur.cursors-4u.net/games/gam-4/gam384.cur'), pointer !important;
  user-select: none;
}
.user-entry:hover {
  border-color: var(--mc-green);
  background: rgba(94, 168, 24, 0.25);
}

.user-entry-avatar {
  width: 44px;
  height: 44px;
  border: 3px solid #fff;
  background: #111;
  image-rendering: pixelated;
}

.user-entry-name {
  font-size: 12px;
  color: #fff;
  text-shadow: 2px 2px 0 #000;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-entry-login {
  font-size: 12px;
  color: #fff;
  text-shadow: 2px 2px 0 #000;
  padding: 6px 10px;
  border: 3px solid #000;
  background: var(--mc-green);
  box-shadow: inset -3px -3px 0 #3c6b10, inset 3px 3px 0 #9ae054;
}

/* 移动端策略 A：保持 PC 布局一致，仅整体缩小显示（不做模块重排） */
@media (max-width: 768px) {
  /* 1) 全页整体缩放：把 PC 页面等比缩小放进手机 */
  .page-container {
    transform: none !important;
    width: 100% !important;
  }

  /* 顶部欢迎页背景（云边小镇）：修复遮挡与下方黑块，高度完全贴合图片 */
  header {
    height: auto !important;
    min-height: auto !important; /* 移除 100vh 限制，防止出现黑色空块 */
    aspect-ratio: 16 / 9; /* 保持图片原始比例 */
    background-attachment: scroll !important;
    background-position: center top !important;
    background-size: 100% auto !important;
    background-repeat: no-repeat !important;
    background-color: transparent !important;
    border-bottom: none !important;
  }

  /* 调整“往下阅览”提示，使其在高度缩减后依然可见并位置合理 */
  .scroll-hint {
    bottom: 10px !important;
    transform: translateX(-50%) scale(0.8) !important;
  }

  /* 轮播图高度适配：在手机上缩小高度，并确保背景图居中且完全覆盖容器 */
  .hero-carousel-container,
  .carousel-container {
    height: 40vh !important;
  }

  .hero-carousel-item,
  .carousel-item {
    background-size: cover !important;
    background-position: center center !important;
  }

  /* 头像介绍区：针对反馈，移动端改为纵向布局以防头像压扁，头像在上文字在下 */
  .founder-strip {
    flex-direction: column !important;
    text-align: center !important;
    padding: 40px 20px !important;
    align-items: center !important;
  }

  .founder-avatar-link {
    width: 120px !important;
    height: 120px !important;
    margin: 0 auto 20px !important;
    display: block !important;
    align-self: center !important;
  }

  .founder-avatar {
    width: 120px !important;
    height: 120px !important;
    object-fit: cover !important;
    border-radius: 4px !important;
    display: block !important;
    margin: 0 auto !important;
  }

  .founder-text {
    flex: 1 !important;
  }

  .founder-text h2 {
    font-size: 16px !important;
    margin-top: 0 !important;
  }

  .founder-text p {
    font-size: 11px !important;
    line-height: 1.6 !important;
    margin-top: 10px !important;
  }

  /* 邮件弹窗卡死修复：开启内容滚动，并确保背景不能滚动 */
  .mail-modal-overlay {
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
    align-items: flex-start !important;
    padding: 15px !important;
  }

  .mc-mail-card {
    margin: 20px auto !important;
    max-height: none !important;
  }

  /* 去除页面底部大片空白 */
  .page-container,
  #app,
  body {
    height: auto !important;
    min-height: auto !important;
  }

  /* 2) 右上角入口条：确保在手机端可见且悬浮在最前 */
  .user-entry-bar {
    position: fixed !important;
    top: 10px !important;
    right: 10px !important;
    z-index: 999999 !important;
    transform: scale(0.8) !important;
    transform-origin: top right !important;
    display: flex !important;
    gap: 8px !important;
  }

  /* 3) 避免 iOS 页面横向滚动条 */
  html,
  body {
    overflow-x: hidden;
  }

  /* 4) 底部留白兜底：避免 transform 缩放后出现异常空白 */
  footer {
    margin-top: 0 !important;
  }
}

/* 全屏轮播图 - 突破容器限制 */
.page-container>.hero-carousel-wrapper,
.page-container>.carousel-wrapper {
  position: relative !important;
  width: 100vw !important;
  max-width: 100vw !important;
  left: 50% !important;
  margin-left: -50vw !important;
  margin-right: 0 !important;
}

.reveal-section {
  opacity: 0;
  filter: blur(40px);
  transform: translateY(50px);
  transition: all 1.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.reveal-section.is-visible {
  opacity: 1;
  filter: blur(0);
  transform: translateY(0);
}

header {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url('https://mosicong.oss-cn-guangzhou.aliyuncs.com/img/%E5%B0%8F%E9%95%87%E5%8A%A8%E5%9B%BE.gif') center/cover no-repeat fixed;
  border-bottom: 12px solid #373737;
  position: relative;
}

.scroll-hint {
  position: absolute;
  left: 50%;
  bottom: 40px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  user-select: none;
  cursor: pointer;
  padding: 6px 8px;
  background: transparent;
  border: none;
  box-shadow: none;
  transition: filter 120ms linear;
}


.scroll-hint-text {
  font-size: 14px;
  color: #fff;
  text-shadow: 2px 2px 0 #000;
  letter-spacing: 1px;
}

.scroll-hint-arrows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  animation: scrollHintBounce 1.2s infinite;
}

/* 双箭头、无箭头柄：用两个 V 形组合 */
.scroll-arrow {
  width: 26px;
  height: 18px;
  position: relative;
}

.scroll-arrow::before,
.scroll-arrow::after {
  content: '';
  position: absolute;
  top: 0;
  width: 16px;
  height: 16px;
  border-right: 6px solid #fff;
  border-bottom: 6px solid #fff;
  filter: drop-shadow(2px 2px 0 #000);
}

.scroll-arrow::before {
  left: 0;
  transform: rotate(45deg);
}

.scroll-arrow::after {
  right: 0;
  transform: rotate(45deg);
}

@keyframes scrollHintBounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(8px);
  }
}

@media (max-width: 560px) {
  .scroll-hint {
    bottom: 26px;
    padding: 9px 12px;
  }

  .scroll-hint-text {
    font-size: 12px;
  }
}

/* 顶部轮播图（来自 /set 轮播图管理） */
.hero-carousel-wrapper {
  display: block !important;
  position: relative !important;
  width: 100vw !important;
  max-width: 100vw !important;
  left: 50% !important;
  margin-left: -50vw !important;
  margin-right: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
  border: none !important;
}

.hero-carousel-container {
  width: 100% !important;
  height: 66.67vh !important;
  position: relative !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  max-width: none !important;
}

.hero-carousel-inner {
  display: flex !important;
  height: 100% !important;
  width: 100% !important;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}

.hero-carousel-item {
  min-width: 100% !important;
  width: 100% !important;
  height: 100% !important;
  flex-shrink: 0 !important;
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background-attachment: scroll;
  background-color: #1a1a1a;
  transition: opacity 0.3s ease-in-out;
  cursor: default !important;
}

.hero-carousel-overlay {
  background: rgba(0, 0, 0, 0.4);
  padding: 20px;
  border: none !important;
  text-align: center;
  box-sizing: border-box;
  z-index: 10;
  display: block;
  position: relative;
}

.hero-carousel-overlay h3 {
  margin: 0;
  font-size: 18px;
  color: white;
  text-shadow: 2px 2px 0 #000;
  font-family: 'Press Start 2P', 'Microsoft YaHei', cursive;
  white-space: nowrap;
  display: block;
}

/* 建筑轮播图（保留原有逻辑） */
.carousel-wrapper {
  display: block !important;
  position: relative !important;
  width: 100vw !important;
  max-width: 100vw !important;
  left: 50% !important;
  margin-left: -50vw !important;
  margin-right: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
  border: none !important;
}

.carousel-container {
  width: 100% !important;
  height: 66.67vh !important;
  position: relative !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  max-width: none !important;
}

.carousel-inner {
  display: flex !important;
  height: 100% !important;
  width: 100% !important;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}

.carousel-item {
  min-width: 100% !important;
  width: 100% !important;
  height: 100% !important;
  flex-shrink: 0 !important;
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background-attachment: scroll;
  background-color: #1a1a1a;
  transition: opacity 0.3s ease-in-out;
}

.carousel-overlay {
  background: rgba(0, 0, 0, 0.4);
  padding: 20px;
  border: none !important;
  text-align: center;
  box-sizing: border-box;
  z-index: 10;
  display: block;
  position: relative;
}

.carousel-overlay h3 {
  margin: 0;
  font-size: 18px;
  color: white;
  text-shadow: 2px 2px 0 #000;
  font-family: 'Press Start 2P', 'Microsoft YaHei', cursive;
  white-space: nowrap;
  display: block;
}

.founder-strip {
  width: 100%;
  background: #2d4e10;
  padding: clamp(40px, 8vw, 100px) 5%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: clamp(20px, 5vw, 60px);
  border-bottom: 10px solid #1a2e0a;
}

@media (max-width: 860px) {
  .founder-strip {
    flex-direction: column;
    text-align: center;
    padding: 60px 20px;
  }
}

.founder-avatar-link {
  display: inline-block;
  flex-shrink: 0;
  align-self: flex-start;
  line-height: 0;
  border: none;
  text-decoration: none;
  border-radius: 8px;
  outline: none;
  position: relative;
  transform-style: preserve-3d;
  transition: filter 0.3s ease;
}

/* 彩带（像素碎片）容器 */
.confetti-container {
  position: absolute;
  inset: -20px;
  pointer-events: none;
  z-index: 10;
}

.confetti-bit {
  position: absolute;
  width: 8px;
  height: 8px;
  top: 50%;
  left: 50%;
  opacity: 0;
  image-rendering: pixelated;
}

/* 随机生成 12 个碎片的初速度和颜色 */
.confetti-bit:nth-child(4n+1) { background: #ff6b6b; }
.confetti-bit:nth-child(4n+2) { background: #4ecdc4; }
.confetti-bit:nth-child(4n+3) { background: #ffe66d; }
.confetti-bit:nth-child(4n+4) { background: #5ea818; }

.founder-avatar-link:hover .confetti-bit {
  animation: confettiPop 0.8s ease-out forwards;
}

/* 碎片弹出动画 */
@keyframes confettiPop {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }
  100% {
    transform: translate(var(--tx), var(--ty)) rotate(var(--tr));
    opacity: 0;
  }
}

/* 为每个碎片设置随机方向偏移 */
.confetti-bit:nth-child(1) { --tx: -60px; --ty: -80px; --tr: 45deg; }
.confetti-bit:nth-child(2) { --tx: 60px; --ty: -70px; --tr: -45deg; }
.confetti-bit:nth-child(3) { --tx: -80px; --ty: 20px; --tr: 90deg; }
.confetti-bit:nth-child(4) { --tx: 80px; --ty: 30px; --tr: -90deg; }
.confetti-bit:nth-child(5) { --tx: -40px; --ty: 80px; --tr: 135deg; }
.confetti-bit:nth-child(6) { --tx: 40px; --ty: 90px; --tr: -135deg; }
.confetti-bit:nth-child(7) { --tx: -90px; --ty: -30px; --tr: 20deg; }
.confetti-bit:nth-child(8) { --tx: 90px; --ty: -20px; --tr: -20deg; }
.confetti-bit:nth-child(9) { --tx: 0px; --ty: -100px; --tr: 0deg; }
.confetti-bit:nth-child(10) { --tx: 0px; --ty: 100px; --tr: 180deg; }
.confetti-bit:nth-child(11) { --tx: -100px; --ty: 0px; --tr: -90deg; }
.confetti-bit:nth-child(12) { --tx: 100px; --ty: 0px; --tr: 90deg; }

.founder-avatar {
  width: clamp(120px, 20vw, 160px);
  height: clamp(120px, 20vw, 160px) !important;
  object-fit: cover;
  display: block;
  border: 8px solid #fff;
  image-rendering: pixelated;
  box-shadow: 10px 10px 0 rgba(0, 0, 0, 0.3);
  transition: 
    border-color 0.3s ease, 
    box-shadow 0.3s ease;
  will-change: transform;
}

.founder-avatar-link:hover .founder-avatar {
  border-color: var(--mc-green);
  /* 悬停时的呼吸光效 */
  animation: avatarGlow 2s infinite ease-in-out;
}

@keyframes avatarGlow {
  0%, 100% {
    box-shadow: 16px 16px 0 rgba(0, 0, 0, 0.4), 0 0 15px rgba(94, 168, 24, 0.4);
  }
  50% {
    box-shadow: 16px 16px 0 rgba(0, 0, 0, 0.4), 0 0 35px rgba(94, 168, 24, 0.8);
  }
}

.founder-avatar-link:active .founder-avatar {
  border-color: #fff;
}

.notice-board {
  padding: clamp(40px, 8vw, 80px) 5%;
  background: #313233;
  text-align: center;
  border-bottom: 8px solid #222;
}

.board-container {
  background: #222;
  border: 4px solid #444;
  padding: 20px;
  margin-bottom: 20px;
  min-height: 150px;
}

.notice-item {
  border-left: 5px solid var(--mc-green);
  background: rgba(255, 255, 255, 0.05);
  padding: 15px;
  margin: 10px 0;
  text-align: left;
  font-size: 16px;
  line-height: 1.8;
}

.desc-section {
  padding: clamp(40px, 10vw, 120px) 5%;
  background: #e0d7c6;
  color: #333;
  border-top: 10px solid #7d5a35;
}

.desc-scroll {
  max-width: 900px;
  margin: 0 auto;
  padding: clamp(20px, 5vw, 40px);
  border: 4px solid #a68966;
  background: #f4efdf;
  box-shadow: 10px 10px 0 rgba(0, 0, 0, 0.1);
}

.desc-scroll h2 {
  color: #5d4328;
  text-align: center;
  margin-bottom: 30px;
  text-decoration: underline;
}

.desc-signature {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

.sig-content {
  text-align: center;
}

.sig-line {
  display: block;
  font-style: italic;
  letter-spacing: 1px;
}

@media (max-width: 768px) {
  .desc-signature {
    margin-top: 30px;
    gap: 6px;
  }
  .sig-line {
    font-size: 11px;
  }
}

.desc-scroll p {
  font-size: clamp(14px, 1.8vw, 18px);
  line-height: 2.2;
  color: #4a3420;
  text-align: justify;
}

.rules-section {
  padding: clamp(40px, 8vw, 80px) 5%;
  background: #222;
  border-top: 8px solid #333;
  text-align: center;
}

.rules-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  max-width: 1100px;
  margin: 40px auto;
}

.rule-card {
  background: #1a1a1a;
  border: 4px solid var(--mc-oak-dark);
  padding: 25px;
  text-align: left;
  position: relative;
}

.rule-card h4 {
  color: var(--mc-green);
  margin-top: 0;
  font-size: 18px;
}

.rule-card p {
  font-size: 16px;
  line-height: 2;
  color: #bbb;
}

.map-wrapper {
  width: 100%;
  height: clamp(300px, 75vh, 95vh);
  position: relative;
  background: #000;
  border: clamp(4px, 2vw, 12px) solid #333;
}

#town-map {
  width: 100%;
  height: 100%;
}

.members-area {
  padding: 100px 5%;
  background: #313233;
  text-align: center;
  border-top: 8px solid #222;
}

.sign-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 30px;
  margin-top: 50px;
  padding: 0 5%;
}

.oak-sign-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s;
}

.oak-sign-box:hover {
  transform: translateY(-5px);
}

.oak-sign-body {
  width: 100%;
  aspect-ratio: 1.8 / 1;
  height: auto;
  min-height: 120px;
  background: var(--mc-oak);
  border: 5px solid var(--mc-oak-dark);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--mc-oak-text);
  font-weight: bold;
  box-shadow: inset 4px 4px 0 #dec09d;
  font-size: clamp(12px, 2vw, 16px);
  padding: 15px;
  text-align: center;
  line-height: 1.4;
  overflow: hidden;
}

.oak-sign-name {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  margin-bottom: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.oak-sign-name span {
  display: inline-block;
  transform-origin: center;
}

.oak-sign-sep {
  opacity: 0.6;
  margin: 2px 0;
}

.oak-sign-title {
  width: 100%;
  font-size: 0.9em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-word;
  opacity: 0.9;
}

.oak-sign-stick {
  width: 20px;
  height: 50px;
  background: var(--mc-oak-dark);
}

.building-gallery {
  width: 100%;
  padding: 80px 0;
  background: #1a1a1a;
  overflow: hidden;
  position: relative;
  border-top: 8px solid #333;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.gallery-track {
  display: flex;
  width: max-content;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.build-card {
  width: clamp(280px, 40vw, 450px);
  height: clamp(180px, 30vw, 300px);
  position: relative;
  flex-shrink: 0;
  border: 4px solid #222;
  margin-right: 15px;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.build-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  pointer-events: none;
}

.build-info {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  padding: 20px;
  transform: translateY(100%);
  transition: 0.3s;
  text-align: center;
  font-size: 10px;
  color: var(--mc-green);
}

.build-card:hover .build-info {
  transform: translateY(0);
}

.history-area {
  padding: clamp(60px, 10vw, 120px) 5%;
  background: #000;
}

.timeline {
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 1000px;
  margin: 0 auto;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  width: 6px;
  height: 100%;
  background: #222;
  transform: translateX(-50%);
}

@media (max-width: 768px) {
  .timeline::before {
    left: 20px;
    transform: none;
  }
}

.history-item {
  width: 42%;
  margin: 40px 0;
  background: #111;
  border: 3px solid var(--mc-green);
  padding: clamp(15px, 4vw, 30px);
  position: relative;
  z-index: 5;
}

@media (max-width: 768px) {
  .history-item {
    width: calc(100% - 60px) !important;
    margin: 20px 0 20px 60px !important;
    align-self: flex-start !important;
  }
}

.history-item h3 {
  font-size: 20px;
  color: var(--mc-green);
  margin-bottom: 15px;
}

.history-item p {
  font-size: 16px;
  line-height: 2.2;
  color: #888;
  text-align: justify;
}

.history-item:nth-child(even) {
  align-self: flex-end;
  margin-left: 8%;
}

.history-item:nth-child(odd) {
  align-self: flex-start;
  margin-right: 8%;
}

.mc-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.9);
  background: #c6c6c6;
  border: 6px solid #000;
  padding: 30px;
  z-index: 99999;
  box-shadow: inset -4px -4px 0 #555, inset 4px 4px 0 #fff;
  display: none;
  flex-direction: column;
  gap: 20px;
  width: 400px;
}

.mc-modal.active {
  display: flex;
  animation: mcPop 0.2s cubic-bezier(0.18, 0.89, 0.32, 1.28) forwards;
}

@keyframes mcPop {
  to {
    transform: translate(-50%, -50%) scale(1);
  }
}

.mc-modal input {
  background: #000;
  color: var(--mc-green);
  border: 3px solid #7a7a7a;
  padding: 15px;
  font-family: inherit;
  font-size: 12px;
  outline: none;
}

.mc-btn {
  padding: 12px;
  border: 3px solid #000;
  font-family: inherit;
  background: #999;
  box-shadow: inset -3px -3px 0 #555, inset 3px 3px 0 #ddd;
  flex: 1;
}

.mc-btn-primary {
  background: var(--mc-green);
  box-shadow: inset -3px -3px 0 #3c6b10, inset 3px 3px 0 #9ae054;
  color: white;
}

#toast {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: -120px;
  background: #000;
  border: 4px solid #fff;
  padding: 20px 40px;
  z-index: 10000;
  transition: 0.5s;
  opacity: 0;
}

#toast.active {
  bottom: 60px;
  opacity: 1;
}

footer {
  padding: 80px;
  text-align: center;
  color: #444;
  font-size: 10px;
  background: #000;
}

.pv-strip {
  width: 100%;
  background: #1a1a1a;
  border-top: 10px solid #2b2b2b;
  border-bottom: 10px solid #101010;
  padding: 70px 10%;
}

.pv-panel {
  max-width: 1100px;
  margin: 0 auto;
  border: 6px solid #000;
  background:
    linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.55)),
    linear-gradient(90deg, #2f7d1b 0 25%, #3e8f27 25% 50%, #2f7d1b 50% 75%, #3e8f27 75% 100%);
  box-shadow: inset -6px -6px 0 rgba(0, 0, 0, 0.45), inset 6px 6px 0 rgba(255, 255, 255, 0.08), 14px 14px 0 rgba(0, 0, 0, 0.35);
  padding: 28px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  position: relative;
}

.pv-panel::before {
  content: '';
  position: absolute;
  left: 12px;
  top: 12px;
  width: 18px;
  height: 18px;
  background: #3cff2f;
  border: 4px solid #000;
  box-shadow: inset -3px -3px 0 rgba(0, 0, 0, 0.35);
}

.pv-left {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pv-title {
  font-size: 18px;
  color: #fff;
  text-shadow: 3px 3px 0 #000;
  letter-spacing: 1px;
}

.pv-sub {
  font-size: 10px;
  color: #d1e8b9;
  text-shadow: 2px 2px 0 #000;
  opacity: 0.95;
}

.pv-right {
  display: flex;
  align-items: flex-end;
  gap: 22px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.pv-count {
  border: 4px solid #000;
  background: rgba(0, 0, 0, 0.55);
  box-shadow: inset -4px -4px 0 rgba(0, 0, 0, 0.35), inset 4px 4px 0 rgba(255, 255, 255, 0.06);
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 220px;
}

.pv-count-label {
  font-size: 9px;
  color: #9ae054;
  text-shadow: 2px 2px 0 #000;
}

.pv-count-value {
  font-size: 22px;
  color: #fff;
  text-shadow: 3px 3px 0 #000;
  margin-top: 6px;
}

.pv-meta {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 10px;
  color: #fff;
  text-shadow: 2px 2px 0 #000;
}

.pv-meta-item {
  padding: 10px 12px;
  border: 4px solid #000;
  background: rgba(0, 0, 0, 0.35);
  box-shadow: inset -3px -3px 0 rgba(0, 0, 0, 0.3), inset 3px 3px 0 rgba(255, 255, 255, 0.06);
  min-width: 260px;
}

@media (max-width: 720px) {
  .pv-strip {
    padding: 50px 6%;
  }

  .pv-panel {
    flex-direction: column;
    align-items: stretch;
  }

  .pv-right {
    justify-content: flex-start;
    align-items: stretch;
  }

  .pv-count {
    align-items: flex-start;
    min-width: auto;
  }

  .pv-meta-item {
    min-width: auto;
  }
}

.server-info {
  width: 100%;
  padding: 80px 10%;
  background: #000;
  border-top: 8px solid #222;
}

.server-info-inner {
  max-width: 1300px;
  margin: 0 auto;
  border: 6px solid #000;
  background:
    linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),
    repeating-linear-gradient(90deg, #2b2b2b 0 26px, #242424 26px 52px);
  box-shadow: inset -6px -6px 0 rgba(0, 0, 0, 0.55), inset 6px 6px 0 rgba(255, 255, 255, 0.06), 16px 16px 0 rgba(0, 0, 0, 0.45);
  padding: 26px;
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 28px;
  align-items: stretch;
  position: relative;
}

.server-info-inner::before {
  content: '';
  position: absolute;
  left: 14px;
  top: 14px;
  width: 18px;
  height: 18px;
  background: #3cff2f;
  border: 4px solid #000;
  box-shadow: inset -3px -3px 0 rgba(0, 0, 0, 0.35);
}

.server-info-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
}

.server-logo-link {
  display: block;
  border: 6px solid #000;
  background: rgba(0, 0, 0, 0.40);
  box-shadow: inset -6px -6px 0 rgba(0, 0, 0, 0.35), inset 6px 6px 0 rgba(255, 255, 255, 0.06);
  padding: 14px;
}

.server-logo-img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  image-rendering: pixelated;
  border: 4px solid rgba(255, 255, 255, 0.12);
}

.server-logo-link:hover {
  transform: translateY(-2px);
}

.server-website-btn {
  padding: 16px 14px;
  border: 4px solid #000;
  font-family: inherit;
  background: var(--mc-green);
  box-shadow: inset -4px -4px 0 #3c6b10, inset 4px 4px 0 #9ae054;
  color: #fff;
  text-shadow: 2px 2px 0 #000;
  font-size: 14px;
}

.server-website-btn:hover {
  filter: brightness(1.05);
}

.server-website-btn:active {
  transform: translateY(1px);
  box-shadow: inset -2px -2px 0 #3c6b10, inset 2px 2px 0 #9ae054;
}

.server-info-right {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.server-info-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border: 6px solid #000;
  background:
    linear-gradient(rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)),
    linear-gradient(90deg, #2f7d1b 0 25%, #3e8f27 25% 50%, #2f7d1b 50% 75%, #3e8f27 75% 100%);
  box-shadow: inset -6px -6px 0 rgba(0, 0, 0, 0.45), inset 6px 6px 0 rgba(255, 255, 255, 0.08);
}

.server-info-name {
  font-size: 20px;
  color: #fff;
  text-shadow: 3px 3px 0 #000;
  letter-spacing: 1px;
}

.server-info-status {
  font-size: 14px;
  padding: 10px 14px;
  border: 4px solid #000;
  background: rgba(0, 0, 0, 0.45);
  box-shadow: inset -3px -3px 0 rgba(0, 0, 0, 0.35), inset 3px 3px 0 rgba(255, 255, 255, 0.06);
  color: #9ae054;
  text-shadow: 2px 2px 0 #000;
}

.server-info-table {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.server-info-row {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 14px;
  padding: 16px 18px;
  border: 6px solid #000;
  background: rgba(0, 0, 0, 0.38);
  box-shadow: inset -6px -6px 0 rgba(0, 0, 0, 0.35), inset 6px 6px 0 rgba(255, 255, 255, 0.06);
  align-items: center;
}

.server-info-k {
  font-size: 15px;
  color: #d1e8b9;
  text-shadow: 2px 2px 0 #000;
}

.server-info-v {
  font-size: 15px;
  color: #fff;
  text-shadow: 2px 2px 0 #000;
  line-height: 1.8;
}

.server-info-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 16px;
  color: #fff;
}

.server-info-note {
  color: #9ae054;
}

.server-info-split {
  display: inline-block;
  margin: 0 12px;
  opacity: 0.7;
}

.server-info-slogan {
  font-size: 13px;
  color: #9ae054;
  text-shadow: 2px 2px 0 #000;
  padding: 6px 4px 0;
}

@media (max-width: 980px) {
  .server-info {
    padding: 60px 6%;
  }

  .server-info-inner {
    grid-template-columns: 1fr;
  }

  .server-info-left {
    max-width: 380px;
  }

  .server-info-row {
    grid-template-columns: 1fr;
  }
}

.mc-banner-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mc-banner-flag {
  width: calc(14px * var(--map-scale));
  height: calc(20px * var(--map-scale));
  background: #fff;
  border: calc(2px * var(--map-scale)) solid #000;
  position: relative;
}

.mc-banner-flag::after {
  content: '';
  position: absolute;
  bottom: calc(-6px * var(--map-scale));
  left: calc(-2px * var(--map-scale));
  border-left: calc(7px * var(--map-scale) + 1px) solid transparent;
  border-right: calc(7px * var(--map-scale) + 1px) solid transparent;
  border-top: calc(6px * var(--map-scale)) solid #000;
}

.mc-banner-text {
  color: #fff;
  text-shadow: 2px 2px 0 #000;
  font-family: 'Microsoft YaHei';
  font-size: calc(12px * var(--map-scale));
  margin-top: 4px;
  white-space: nowrap;
}

/* --- 邮件系统相关样式 --- */
.mc-mailbox {
  position: relative;
  margin-right: 20px;
  cursor: pointer;
  z-index: 10001;
}

.mc-mailbox-badge {
  position: absolute;
  top: -12px;
  right: -12px;
  background: #ff0000;
  color: white;
  font-size: 10px;
  padding: 2px 5px;
  border: 2px solid #000;
  z-index: 10;
  font-family: 'Press Start 2P', cursive;
  box-shadow: 2px 2px 0 rgba(0,0,0,0.3);
}

.mc-envelope {
  position: relative;
  width: 42px;
  height: 28px;
  background: #f4efe4;
  border: 3px solid #000;
  box-shadow:
    inset -3px -3px 0 rgba(0,0,0,0.10),
    inset 3px 3px 0 rgba(255,255,255,0.12),
    5px 5px 0 rgba(0,0,0,0.20);
  transition: transform 0.22s ease, filter 0.22s ease;
  image-rendering: pixelated;
}

.user-mail-button:hover .mc-envelope {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

.env-body {
  position: absolute;
  inset: 0;
  z-index: 2;
}

.env-flap {
  position: absolute;
  top: -3px;
  left: -3px;
  width: calc(100% + 6px);
  height: 100%;
  background: #efe6d7;
  border: 3px solid #000;
  clip-path: polygon(0 0, 50% 52%, 100% 0);
  z-index: 4;
  transform-origin: top;
  transition: transform 0.35s cubic-bezier(0.2, 0.8, 0.2, 1);
  box-shadow: inset 0 -2px 0 rgba(0,0,0,0.12);
}

.env-letter {
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  height: 16px;
  background:
    repeating-linear-gradient(
      0deg,
      rgba(0,0,0,0.05),
      rgba(0,0,0,0.05) 1px,
      rgba(255,255,255,0.08) 1px,
      rgba(255,255,255,0.08) 4px
    ),
    #f7f2e7;
  border: 2px solid rgba(0,0,0,0.28);
  box-shadow: inset 0 2px 0 rgba(255,255,255,0.35);
  z-index: 1;
  transition: transform 0.35s 0.08s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.mc-envelope.open .env-flap {
  transform: rotateX(180deg);
  z-index: 1;
}

.mc-envelope.open .env-letter {
  transform: translateY(-15px);
}

/* 邮件弹窗 */
.mail-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px;
  opacity: 0;
  animation: mcOverlayIn 0.22s ease forwards;
}

.mail-modal-overlay.closing {
  animation: mcOverlayOut 0.18s ease forwards;
}

@keyframes mcOverlayIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes mcOverlayOut {
  from { opacity: 1; }
  to { opacity: 0; }
}

.mail-modal-overlay::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(900px 520px at 55% 40%, rgba(94, 168, 24, 0.22), transparent 60%),
    radial-gradient(700px 460px at 35% 65%, rgba(154, 224, 84, 0.16), transparent 60%);
  pointer-events: none;
}

@supports (backdrop-filter: blur(1px)) {
  .mail-modal-overlay {
    backdrop-filter: blur(10px);
  }
}

.mc-mail-card {
  width: min(540px, 94vw);
  background: linear-gradient(180deg, #d7d7d7 0%, #bfbfbf 100%);
  border: 6px solid #000;
  box-shadow:
    inset -4px -4px 0 rgba(0, 0, 0, 0.35),
    inset 4px 4px 0 rgba(255, 255, 255, 0.65),
    18px 18px 0 rgba(0, 0, 0, 0.45);
  display: flex;
  flex-direction: column;
  position: relative;
  transform: translateY(10px) scale(0.97);
  opacity: 0;
  animation: mcMailIn 0.22s cubic-bezier(0.18, 0.89, 0.32, 1.28) forwards;
  overflow: hidden;
}

.mc-mail-card.closing {
  animation: mcMailOut 0.18s ease forwards;
}

@keyframes mcMailIn {
  from { transform: translateY(12px) scale(0.97); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}

@keyframes mcMailOut {
  from { transform: translateY(0) scale(1); opacity: 1; }
  to { transform: translateY(12px) scale(0.97); opacity: 0; }
}

.mc-mail-card.shake {
  animation: mcMailShake 0.42s cubic-bezier(.36,.07,.19,.97) both;
}

@keyframes mcMailShake {
  10%, 90% { transform: translate3d(-2px, 0, 0); }
  20%, 80% { transform: translate3d(4px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-6px, 0, 0); }
  40%, 60% { transform: translate3d(6px, 0, 0); }
}

.mc-mail-header {
  padding: 12px 16px;
  background: linear-gradient(180deg, #3c3c3c 0%, #1c1c1c 100%);
  border-bottom: 6px solid #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 14px;
  text-shadow: 2px 2px 0 #000;
  position: relative;
  z-index: 2;
}

.mc-mail-title {
  font-size: 14px;
  line-height: 1;
  padding: 6px 10px;
  border: 3px solid #000;
  background: rgba(0, 0, 0, 0.25);
  box-shadow: inset -2px -2px 0 rgba(0, 0, 0, 0.35), inset 2px 2px 0 rgba(255, 255, 255, 0.08);
}

.mc-close-btn {
  position: relative;
  cursor: pointer;
  width: 38px;
  height: 32px;
  display: grid;
  place-items: center;
  border: 4px solid #000;
  background: rgba(0, 0, 0, 0.28);
  color: #ff6b6b;
  font-size: 22px;
  line-height: 1;
  transition: transform 140ms ease, filter 140ms ease, background 140ms ease, box-shadow 140ms ease;
  box-shadow: inset -2px -2px 0 rgba(0, 0, 0, 0.35), inset 2px 2px 0 rgba(255, 255, 255, 0.08);
}

.mc-close-btn:hover {
  transform: translateY(-1px) scale(1.06) rotate(-6deg);
  filter: brightness(1.08);
  background: rgba(255, 85, 85, 0.14);
  box-shadow:
    inset -2px -2px 0 rgba(0, 0, 0, 0.35),
    inset 2px 2px 0 rgba(255, 255, 255, 0.10),
    0 0 0 4px rgba(255, 85, 85, 0.16);
}

.mc-close-btn:active {
  transform: translateY(0) scale(0.98) rotate(0deg);
  filter: brightness(0.98);
}

.mc-close-btn::after {
  content: '';
  position: absolute;
  inset: -6px;
  border: 2px solid rgba(255, 255, 255, 0.12);
  pointer-events: none;
  opacity: 0;
  transition: opacity 140ms ease;
}

.mc-close-btn:hover::after {
  opacity: 1;
}

.mc-mail-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: min(80vh, 620px);
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  z-index: 1;
}

.mc-mail-body::-webkit-scrollbar {
  width: 10px;
}

.mc-mail-body::-webkit-scrollbar-thumb {
  background: linear-gradient(#2f7d1b, #3e8f27);
  border: 3px solid #000;
}

.mc-mail-body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.18);
  border-left: 3px solid #000;
}

.form-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  width: 100%;
}

.form-item {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  border: 4px solid #000;
  background: rgba(255, 255, 255, 0.55);
  box-shadow:
    inset -3px -3px 0 rgba(0, 0, 0, 0.18),
    inset 3px 3px 0 rgba(255, 255, 255, 0.65);
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.form-item.error-border {
  border-color: #ff5555;
  background: rgba(255, 85, 85, 0.1);
  animation: mcItemInnerShake 0.3s;
}

@keyframes mcItemInnerShake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-2px); }
  75% { transform: translateX(2px); }
}

.required-star {
  color: #ff5555;
  margin-left: 2px;
}

.loading-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 3px solid rgba(255,255,255,.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: mcSpin 0.8s linear infinite;
  margin-right: 8px;
}

@keyframes mcSpin {
  to { transform: rotate(360deg); }
}

.form-item label {
  font-size: 11px;
  color: #1b1b1b;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.form-item input,
.form-item select,
.form-item textarea {
  width: 100%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.95);
  border: 4px solid #000;
  padding: 11px 12px;
  font-family: inherit;
  font-size: 13px;
  outline: none;
  box-shadow: inset 3px 3px 0 rgba(0, 0, 0, 0.12);
  transition: transform 120ms ease, filter 120ms ease, box-shadow 120ms ease;
}

.form-item input:focus,
.form-item select:focus,
.form-item textarea:focus {
  transform: translateY(-1px);
  filter: brightness(1.02);
  box-shadow:
    inset 3px 3px 0 rgba(0, 0, 0, 0.12),
    0 0 0 4px rgba(94, 168, 24, 0.35);
}

.mc-custom-select {
  position: relative;
  width: 100%;
  user-select: none;
}

.mc-select-trigger {
  width: 100%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.95);
  border: 4px solid #000;
  padding: 10px 40px 10px 12px;
  font-family: inherit;
  font-size: 13px;
  min-height: 46px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: inset 3px 3px 0 rgba(0, 0, 0, 0.12);
  transition: transform 120ms ease, filter 120ms ease, box-shadow 120ms ease;
  line-height: 1.4;
  position: relative;
}

.mc-select-trigger span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 2px;
  color: #1b1b1b;
}

.mc-select-trigger span.placeholder {
  color: #888;
}

.mc-select-trigger:hover {
  filter: brightness(1.02);
}

.mc-select-arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 4H10L6 8L2 4Z' fill='black'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  pointer-events: none;
  transition: transform 180ms cubic-bezier(0.2, 0.8, 0.2, 1);
}

.mc-custom-select.open .mc-select-arrow {
  transform: translateY(-50%) rotate(180deg);
}

.mc-select-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: transparent;
  border: none;
  z-index: 100;
  max-height: 320px;
  pointer-events: none;
  transition: opacity 250ms ease;
}

.mc-select-options.visible {
  pointer-events: auto;
  opacity: 1;
  transition-delay: 0s;
}

.mc-select-options:not(.visible) {
  opacity: 0;
  transition-delay: 300ms; /* 增加延迟，确保所有选项完成从下往上的收回动画 */
}

.mc-options-inner {
  background: transparent;
  border: 0 solid #000;
  box-shadow: none;
  overflow-y: auto;
  max-height: 320px;
  transition: border-width 150ms, box-shadow 150ms, background-color 150ms;
}

.mc-select-options.visible .mc-options-inner {
  background-color: #f4efe4;
  border-width: 4px;
  box-shadow: 6px 6px 0 rgba(0, 0, 0, 0.35);
  transition-delay: 0s;
}

.mc-select-options:not(.visible) .mc-options-inner {
  transition-delay: 250ms; /* 同步延迟 */
}

.mc-option {
  padding: 7px 12px;
  font-size: 13px;
  color: #372511;
  cursor: pointer;
  transition: background 0.1s, color 0.1s, opacity 200ms cubic-bezier(0.2, 0.8, 0.2, 1), transform 250ms cubic-bezier(0.2, 0.8, 0.2, 1);
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.15;
  background: #f4efe4;
}

.mc-option:hover {
  background: var(--mc-green);
  color: #fff;
}

.mc-option:not(:last-child) {
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}

.mc-select-options::-webkit-scrollbar {
  width: 8px;
}

.mc-select-options::-webkit-scrollbar-thumb {
  background: #000;
  border: 2px solid #f4efe4;
}

.mc-select-options::-webkit-scrollbar-track {
  background: #f4efe4;
}

.mc-stagger-enter-active,
.mc-stagger-leave-active {
  transition: opacity 140ms cubic-bezier(0.2, 0.8, 0.2, 1),
              transform 160ms cubic-bezier(0.2, 0.8, 0.2, 1);
  will-change: transform, opacity;
}

.mc-stagger-enter-from,
.mc-stagger-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.mc-stagger-enter-to,
.mc-stagger-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.mc-stagger-move {
  transition: transform 160ms cubic-bezier(0.2, 0.8, 0.2, 1);
}

.form-item textarea {
  height: 140px;
  resize: none;
}

.content-item {
  padding: 12px;
}

.code-item {
  grid-column: 1 / -1;
}

.code-input-group {
  display: grid;
  grid-template-columns: 1fr 98px;
  gap: 10px;
  align-items: stretch;
}

.code-input-group input {
  width: 100%;
}

.mc-mini-btn {
  padding: 0 12px;
  background: linear-gradient(180deg, #5ea818 0%, #3e8f27 100%);
  border: 4px solid #000;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  box-shadow: inset -3px -3px 0 #2f7d1b, inset 3px 3px 0 #9ae054;
  transition: transform 120ms ease, filter 120ms ease;
  white-space: nowrap;
  min-width: 98px;
}

.mc-mini-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

.mc-mini-btn:active {
  transform: translateY(0);
  filter: brightness(0.98);
}

.mc-mini-btn:disabled {
  background: linear-gradient(180deg, #6c6c6c 0%, #4d4d4d 100%);
  cursor: not-allowed;
  box-shadow: inset -3px -3px 0 #3b3b3b, inset 3px 3px 0 #8a8a8a;
  opacity: 0.9;
}

.mc-mail-footer {
  padding: 16px 18px 18px;
  border-top: 6px solid #000;
  position: relative;
  z-index: 1;
}

.mc-mail-footer .mc-btn-primary.full-width {
  padding: 16px 14px;
  font-size: 14px;
  letter-spacing: 1px;
  text-shadow: 2px 2px 0 #000;
  transition: transform 120ms ease, filter 120ms ease;
}

.mc-mail-footer .mc-btn-primary.full-width:hover {
  transform: translateY(-2px);
  filter: brightness(1.05);
}

.mc-mail-footer .mc-btn-primary.full-width:active {
  transform: translateY(0);
  filter: brightness(0.98);
}

.full-width {
  width: 100%;
}

@media (max-width: 560px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .mc-mail-body {
    max-height: 70vh;
  }

  .code-input-group {
    grid-template-columns: 1fr 92px;
  }
}
</style>
